import React from 'react';
import classNames from 'classnames';
import Slide from './Slide';
import Layout from './Layout';
import Overlay from './Overlay';
import HorizontalScroll from './HorizontalScroll';
import SlideHeading from './SlideHeading';
import Themes from './Themes';
import Map from './Map';
import CrossFadeImages from './CrossFadeImages';
import AudioLink from './Audio';
import VideoLink from './Video';
import VideoFrame from './VideoFrame';
import {Link} from 'react-router-dom';
import Fade from 'react-reveal/Fade';
import GallerySection from './GallerySection';

import slideStyles from './css-modules/slide.module.css';
import layoutStyles from './css-modules/Layout.module.css';
import imageStyles from './css-modules/image_styles.module.css';
import galleryNavStyles from './css-modules/gallery_nav.module.scss';

import mapBg from '../resources/themeBackgrounds/Navigate Theme – Map – 1.jpg';
import literatureBg from '../resources/themeBackgrounds/Navigate Theme – Literature – 1.jpg';
import galleryBg from '../resources/themeBackgrounds/Navigate Theme – Gallery – 1.jpg';
import literatureSlideBg from '../resources/themeBackgrounds/Navigate Theme – Literature – 2.jpg';
import gallerySlideBg from '../resources/themeBackgrounds/Navigate Theme – Gallery – 2.jpg';

import ProjectTitleBack from '../resources/backgrounds/Main Title.jpg';
import ProjectThemesBack from '../resources/backgrounds/Themes_bg.jpg';
import ProjectCreditsBack from '../resources/backgrounds/Credits.jpg';
import MapSolidBg from '../resources/backgrounds/map_solid_bg.jpg';

import Aitchison_Old from '../resources/old_new/Aitchison College/Aitcheson College c. 1910s.jpeg';
import Aitchison_Now from '../resources/old_new/Aitchison College/Aitchison College.jpeg';
import Aitchison_Gall_1 from '../resources/More photos/Aitchison College/ac.jpg';
import Aitchison_Gall_2 from '../resources/More photos/Aitchison College/Aitcheson College Old Building (the album of Private J W Linley 1923-1938).jpeg';
import Aitchison_Gall_3 from '../resources/More photos/Aitchison College/Aitcheson College c. 1900s.jpg';
import Aitchison_Gall_4 from '../resources/More photos/Aitchison College/Aitcheson College c. 1920 .jpeg';
import Aitchison_Gall_5 from '../resources/More photos/Aitchison College/AC_Cent.png';

import Zamzama_Old from '../resources/old_new/Zamzama Toop/Zam-Zamac1920.jpg';
import Zamzama_Now from '../resources/old_new/Zamzama Toop/Zamzama Toop.jpg';
import Zamzama_Gall_1 from '../resources/More photos/zamzamah/Zamzama (Ricalton, Jones, 1903).jpg';
import Zamzama_Gall_2 from '../resources/More photos/zamzamah/Zamzamah in front of University Hall c. 1910.jpg';
import Zamzama_Gall_3 from '../resources/More photos/zamzamah/Zamzama c. 1940s.jpg';
import Zamzama_Gall_4 from '../resources/More photos/zamzamah/Zamzama (closeup of plaque) c. 1946.jpg';
import Zamzama_Gall_5 from '../resources/More photos/zamzamah/Zamzama-Kim-c1960.jpg';
import Zamzama_Gall_6 from '../resources/More photos/zamzamah/Zamzama c. 1970s.jpg';
import Zamzama_Gall_7 from '../resources/More photos/zamzamah/KG.png';

import PPL_Old from '../resources/old_new/Punjab Public Library/Punjab Public Library_Old.jpg';
import PPL_Now from '../resources/old_new/Punjab Public Library/Punjab Public Library.jpeg';
import PPL_Gall_1 from '../resources/More photos/Punjab Public Library/Punjab Public Library 1920.jpeg';
import PPL_Gall_2 from '../resources/More photos/Punjab Public Library/Punjab Public Library 1938.jpeg';
import PPL_Gall_3 from '../resources/More photos/Punjab Public Library/Punjab Public library c. 1870.jpeg';

import Tollinton_Old from '../resources/old_new/Tollinton Market/Tollinton Market c. 1907.jpg';
import Tollinton_Now from '../resources/old_new/Tollinton Market/Tollinton Market.jpg';
import Tollinton_Gall_1 from '../resources/More photos/Tollinton Market/Poster of Punjab Industrial Exhibition aka Tollinton Market c. 1893.jpg';
import Tollinton_Gall_3 from '../resources/More photos/Tollinton Market/Tollinton Market, or Inside View of the Exhibition Building.jpg';
import Tollinton_Gall_4 from '../resources/More photos/Tollinton Market/Tollinton Market, or, Opening of the Punjaub Exhibition of Arts and Industry at Lahore, from Illustrated London News, 1864.jpg';
import Tollinton_Gall_5 from '../resources/More photos/Tollinton Market/Tollinton-Market,-The-Mall.jpg';
import Tollinton_Gall_6 from '../resources/More photos/Tollinton Market/Tollinton Market and Railway Building Labor Returns.jpg';
import Tollinton_Gall_8 from '../resources/More photos/Tollinton Market/Tollinton Market under contruction c. 1863.jpg';
import Tollinton_Gall_9 from '../resources/More photos/Tollinton Market/Tollington.jpeg';

import GPO_Old from '../resources/old_new/GPO/Lahore General Post Office c. 1910s.jpg';
import GPO_Now from '../resources/old_new/GPO/General Post Office.jpg';
import GPO_Gall_1 from '../resources/More photos/GPO/General Post Office c. 1910s.jpg';
import GPO_Gall_3 from '../resources/More photos/GPO/General Post Office c. 1910s (1).jpg';
import GPO_Gall_4 from '../resources/More photos/GPO/General Post Office c. 1964.jpg';
import GPO_Gall_9 from '../resources/More photos/GPO/general-post-office_0.jpg';
import GPO_Gall_11 from '../resources/More photos/GPO/GPO2.jpg';
import GPO_Gall_12 from '../resources/More photos/GPO/Ps9-190.png';

import Anarkali_Old from '../resources/old_new/Anarkali Tomb/anarkali old.jpg';
import Anarkali_Now from '../resources/old_new/Anarkali Tomb/AnarkaliStreet.jpg';
import Anarkali_Gall_1 from '../resources/More photos/Anarkali/Nila gumbat.jpeg';
import Anarkali_Gall_2 from '../resources/More photos/Anarkali/anarkali.jpeg';
import Anarkali_Gall_3 from '../resources/More photos/Anarkali/anakali-2-lahore.jpg';
import Anarkali_Gall_5 from '../resources/More photos/Anarkali/Street-view-Anarkali-1980.png';
import Anarkali_Gall_6 from '../resources/More photos/Anarkali/ad.jpg';

//import GangaRamTrust_Old from '../resources/old_new/Ganga Ram Trust/Tollinton Market c. 1907.jpg';
import GangaRamTrust_Now from '../resources/old_new/Ganga Ram Trust/Ganga Ram Trust Building.jpg';
import HighCourt_Old from '../resources/old_new/Lahore High Court/Lahore High court c. 1940s.jpg';
import HighCourt_Now from '../resources/old_new/Lahore High Court/Lahore-High-Court.jpg';
import HighCourt_Gall_1 from '../resources/More photos/High Court/John Lawrence statue c. 1910s.jpg';
import HighCourt_Gall_4 from '../resources/More photos/High Court/Lahore High Court c. 1908.jpg';
import HighCourt_Gall_5 from '../resources/More photos/High Court/Lahore High court c. 1960s.jpg';
import HighCourt_Gall_7 from '../resources/More photos/High Court/Lahore High court, an albumen photo, c. 1880s.jpg';
import HighCourt_Gall_8 from '../resources/More photos/High Court/Lahore High Court.jpg';
import HighCourt_Gall_10 from '../resources/More photos/High Court/Lahore High Court Bar Association Library c. 1933.jpg';
import HighCourt_Gall_12 from '../resources/More photos/High Court/Lahore High Court W. c. 1925.jpg';
import HighCourt_Gall_17 from '../resources/More photos/High Court/HighCourt.png';
import HighCourt_Gall_19 from '../resources/More photos/High Court/Lawrence statue c. 1920.jpg';

import YMCA_Old from '../resources/old_new/YMCA/YMCA c. 1920.jpeg';
import YMCA_Now from '../resources/old_new/YMCA/YMCA building.jpg';

import GhulamRasool_Old from '../resources/old_new/GRasul/Ghulam Rasool (Smith and Campbell 1922).jpg';
import GhulamRasool_Now from '../resources/old_new/GRasul/GRasul.jpeg';

import CharingCross_Old from '../resources/old_new/Chairing Cross/Charing Cross Pavillion c. 1910s Victoria statue.jpg';
import CharingCross_Now from '../resources/old_new/Chairing Cross/Chairing Cross.jpg';
import CharingCross_Gall_1 from '../resources/More photos/Charing Cross/Charing Cross c. 1930s.jpg';
import CharingCross_Gall_2 from '../resources/More photos/Charing Cross/Charing Cross c. 1973.jpg';
import CharingCross_Gall_3 from '../resources/More photos/Charing Cross/Charing Cross Pavillion (the album of Private J W Linley 1923-1938).jpg';
import CharingCross_Gall_4 from '../resources/More photos/Charing Cross/Charing cross Pavillion c. 1960s no Statue.jpg';
import CharingCross_Gall_6 from '../resources/More photos/Charing Cross/Charing Cross Pavillion installation ceremony of Victoria_s statue.jpg';
import CharingCross_Gall_7 from '../resources/More photos/Charing Cross/VictoriaSS.jpg';

import Freemasons_One from '../resources/old_new/Freemasons Hall/Freemason_s Hall, Plaque.jpg';
import Freemasons_Two from '../resources/old_new/Freemasons Hall/Freemason_s Hall.jpg';
import Freemasons_Three from '../resources/old_new/Freemasons Hall/freemason hall.jpg';

import AlhamraArt from '../resources/old_new/Alhamra/AlhamraArt.jpg';

import DyalSinghMansion_Old from '../resources/old_new/Dyal Singh Mansion/Dyal-Singh-Building---The-Mall,-Lahore-c.jpg';
import DyalSinghMansion_Now from '../resources/old_new/Dyal Singh Mansion/Dyal Singh Building.jpg';
import DyalSinghMansion_Gall_1 from '../resources/More photos/Dyal Singh Building/Dyal SIngh Building c. 1959.jpg';
import DyalSinghMansion_Gall_2 from '../resources/More photos/Dyal Singh Building/Dyal SIngh Building c. 1930s.jpg';

import PunjabAssembly_Old from '../resources/old_new/Punjab Assembly/Punjab Assembly Hall c. 1940s.jpg';
import PunjabAssembly_Now from '../resources/old_new/Punjab Assembly/Punjab Assembly.jpg';
import PunjabAssembly_Gall_1 from '../resources/More photos/Punjab Assembly/Punjab Assembly Hall c. 1940s.jpg';
import PunjabAssembly_Gall_2 from '../resources/More photos/Punjab Assembly/Punjab Assembly Hall c. 1940.jpg';
import PunjabAssembly_Gall_3 from '../resources/More photos/Punjab Assembly/Punjab Assembly House Alfalah building charring cross.jpeg';

//import Alhamra_Old from '../resources/old_new/Tollinton Market/Tollinton Market c. 1907.jpg';
//import Alhamra_Now from '../resources/old_new/Tollinton Market/Tollinton Market.jpg';
import GovernorHouse_Old from '../resources/old_new/Government House/Government House c. 1875.jpg';
import GovernorHouse_Now from '../resources/old_new/Government House/Government House.jpeg';
import GovernorHouse_Gall_1 from '../resources/More photos/Government House/Government house, albumen print by Bourne.jpg';
import GovernorHouse_Gall_2 from '../resources/More photos/Government House/Government House, Lahore c. 1869.jpg';
import GovernorHouse_Gall_3 from '../resources/More photos/Government House/Government House, Lahore c. 1910 (Postcard).jpg';
import GovernorHouse_Gall_4 from '../resources/More photos/Government House/Government House c.1910.jpg';
import GovernorHouse_Gall_6 from '../resources/More photos/Government House/new doc 2019-12-23 15.03.19_1.jpg';

import NCA_Old from '../resources/old_new/NCA/NCA_old.jpg';
import NCA_Now from '../resources/old_new/NCA/NCA_new.jpg';
import NCA_Gall_1 from '../resources/More photos/NCA/NCA c. 1910.jpg';
import NCA_Gall_2 from '../resources/More photos/NCA/NCA c. 1911.jpg';
import NCA_Gall_3 from '../resources/More photos/NCA/NCA c. 1890.jpg';
import NCA_Gall_4 from '../resources/More photos/NCA/NCA_Cent.png';

import mapBackground from '../resources/map/mall road map without text.jpg';

import Bano from '../resources/media/Bano.jpg';
import Kim from '../resources/media/Kim.jpg';
import LambiSarak from '../resources/media/Lambi Sarak.jpg';
import Overcoat from '../resources/media/Overcoat.jpg';

import aitchison_audio from '../resources/audio/Aithison.mp3';
import dyal_singh_audio from '../resources/audio/Dyal Singh.mp3';
import government_audio from '../resources/audio/Governor House.mp3';
import GPO_audio from '../resources/audio/GPO.mp3';
import NCA_audio from '../resources/audio/NCA.mp3';
import PPL_audio from '../resources/audio/PPL.mp3';
import YMCA_audio from '../resources/audio/YMCA.mp3';
import Zamzama_audio from '../resources/audio/Zamzama.mp3';
import high_court_audio from '../resources/audio/Courts.mp3';
import anarkali_audio from '../resources/audio/Manto.mp3';
import ganga_ram_audio from '../resources/audio/Ganga Ram Building.mp3';
import masonic_audio from '../resources/audio/Masonic.mp3';
import churchill_audio from '../resources/audio/Churchill.mp3';
import museam_audio from '../resources/audio/Lahore Museam.mp3';
import ganga_ram_hospital_audio from '../resources/audio/Ganga Ram Hospital.mp3';
import mont_audio from '../resources/audio/Montgomery Hall.mp3';
import mont1_audio from '../resources/audio/Montgomery Hall 1.mp3';
import lawrance_garden from '../resources/audio/Lawrance Gardens.mp3';
import lawrance_stat_audio from '../resources/audio/Lawrance Statue.mp3';

import advertisement_Gallery1 from '../resources/More photos/Gallery/Ad_Alhamra.jpg';
import advertisement_Gallery2 from '../resources/More photos/Gallery/Ad_museum.jpg';
import advertisement_Gallery3 from '../resources/More photos/Gallery/Ad_NCA.jpg';
import advertisement_Gallery4 from '../resources/More photos/Gallery/Ad_NCA1.jpg';
import advertisement_Gallery5 from '../resources/More photos/Gallery/Ad_Tollington.jpg';
import advertisement_Gallery6 from '../resources/More photos/Gallery/NCADrama.jpg';
import advertisement_Gallery7 from '../resources/More photos/Gallery/Himani Soap Ad.jpg';


import places_Gallery1 from '../resources/More photos/Gallery/Cathedral1.jpg';
import places_Gallery2 from '../resources/More photos/Gallery/Cathedral2.jpg';
import places_Gallery3 from '../resources/More photos/Gallery/LawrenceHall1.jpg';
import places_Gallery4 from '../resources/More photos/Gallery/LawrenceHall2.jpg';
import places_Gallery5 from '../resources/More photos/Gallery/LawrenceHall3.jpg';
import places_Gallery6 from '../resources/More photos/Gallery/LawrenceHall4.jpg';
import places_Gallery7 from '../resources/More photos/Gallery/Museum1.jpg';
import places_Gallery8 from '../resources/More photos/Gallery/Museum2.jpg';
import places_Gallery9 from '../resources/More photos/Gallery/NCA1.jpg';
import places_Gallery10 from '../resources/More photos/Gallery/NCA2.png';
import places_Gallery11 from '../resources/More photos/Gallery/NCA3.jpg';
import places_Gallery12 from '../resources/More photos/Gallery/NCA4.jpg';
import places_Gallery13 from '../resources/More photos/Gallery/Regal1.jpg';
import places_Gallery14 from '../resources/More photos/Gallery/Telegraph.jpg';
import places_Gallery15 from '../resources/More photos/Gallery/Telegraph2.jpg';
import places_Gallery16 from '../resources/More photos/Gallery/TownHall.png';
import places_Gallery17 from '../resources/More photos/Gallery/TownHall2.jpg';
import places_Gallery18 from '../resources/More photos/Gallery/TownHall3.jpg';
import places_Gallery19 from '../resources/More photos/Gallery/UniversityHall.jpg';
import places_Gallery20 from '../resources/More photos/Gallery/Zoo1940.png';
import places_Gallery21 from '../resources/More photos/Gallery/ZooPlaque.jpg';

import general_Gallery1 from '../resources/More photos/Gallery/Mall1930_1.jpg';
import general_Gallery2 from '../resources/More photos/Gallery/Mall1930_2.jpg';
import general_Gallery3 from '../resources/More photos/Gallery/Mall1930.jpg';
import general_Gallery4 from '../resources/More photos/Gallery/Mall1941.jpg';
import general_Gallery5 from '../resources/More photos/Gallery/Mall1950.png';
import general_Gallery6 from '../resources/More photos/Gallery/Mall1959_2.jpg';
import general_Gallery7 from '../resources/More photos/Gallery/Mall1959.jpg';
import general_Gallery8 from '../resources/More photos/Gallery/MallAerial.jpg';
import general_Gallery9 from '../resources/More photos/Gallery/MallMap1.jpg';
import general_Gallery10 from '../resources/More photos/Gallery/MallMap2.jpg';
import general_Gallery11 from '../resources/More photos/Gallery/MallMap3.jpg';
import general_Gallery12 from '../resources/More photos/Gallery/MallSS.jpg';
import general_Gallery13 from '../resources/More photos/Gallery/Picture taken from Cathedral Bell Tower c. 1900s.jpg'
import general_Gallery14 from '../resources/More photos/Gallery/Picture taken from Cathedral Bell Tower c. 1985 (Bryan Porter).jpg'

import painting_Gallery1 from '../resources/More photos/Gallery/MallPainting1.jpg';
import painting_Gallery2 from '../resources/More photos/Gallery/MallPainting2.jpg';

import stamp_Gallery1 from '../resources/More photos/Gallery/stampMuseum.png';
import stamp_Gallery2 from '../resources/More photos/Gallery/stampNCA.png';

import poem_Gallery1 from '../resources/More photos/Gallery/PoemLHR.jpg';

import narration_Gallery1 from '../resources/More photos/Gallery/Sir_Winston_Churchill.jpg';
import narration_Gallery2 from '../resources/More photos/Gallery/Sir-Ganga-Ram.jpg';

import main from '../resources/navbackgrounds/main.jpg';
import political from '../resources/navbackgrounds/political.jpg';
import twomurders from '../resources/navbackgrounds/twomurders.jpg';
import mallroad from '../resources/navbackgrounds/mallroad.jpg';
import literary from '../resources/navbackgrounds/literary.jpg';
import hindu from '../resources/navbackgrounds/hindu.jpg';
import ProjectTitle from '../slide-components/Project_Title';
import ProjectCredits from '../slide-components/Project_Credits';


import { MdChevronRight } from "react-icons/md";
import { MdChevronLeft } from "react-icons/md";

//Import Mobile Components

import MobileSlide from './MobileSlide';
import ProjectTitleMobile from './mobile-components/Project_Title_Mob';
import mobileStyles from './css-modules/mobileStyles.module.css';
import ProjectCreditsMobile from './mobile-components/Project_Credits_Mob';
import overlay_styles from './css-modules/overlay.module.css';
import MobileGallerySections from './mobile-components/mobileGalleryBrowseSection';

const imageArr = [ProjectTitleBack,ProjectThemesBack,ProjectCreditsBack,MapSolidBg,Aitchison_Old,Aitchison_Now,Aitchison_Gall_1,Aitchison_Gall_2,Aitchison_Gall_3,Aitchison_Gall_4,Aitchison_Gall_5,Zamzama_Old,
Zamzama_Now,Zamzama_Gall_1,Zamzama_Gall_2,Zamzama_Gall_3,Zamzama_Gall_4,Zamzama_Gall_5,Zamzama_Gall_6,Zamzama_Gall_7,PPL_Old,PPL_Now,PPL_Gall_1,PPL_Gall_2,PPL_Gall_3,Tollinton_Old,Tollinton_Now,
Tollinton_Gall_1,Tollinton_Gall_3,Tollinton_Gall_4,Tollinton_Gall_5,Tollinton_Gall_6,Tollinton_Gall_8,Tollinton_Gall_9,GPO_Old,GPO_Now,GPO_Gall_1,GPO_Gall_3,GPO_Gall_4,GPO_Gall_9,GPO_Gall_11,GPO_Gall_12,
Anarkali_Old,Anarkali_Now,Anarkali_Gall_1,Anarkali_Gall_2,Anarkali_Gall_3,Anarkali_Gall_5,Anarkali_Gall_6,GangaRamTrust_Now,HighCourt_Old,HighCourt_Now,HighCourt_Gall_1,HighCourt_Gall_4,HighCourt_Gall_5,HighCourt_Gall_7,HighCourt_Gall_8,HighCourt_Gall_10,HighCourt_Gall_12,HighCourt_Gall_17,HighCourt_Gall_19, YMCA_Old, YMCA_Now, GhulamRasool_Old, GhulamRasool_Now, CharingCross_Old, CharingCross_Now, CharingCross_Gall_1, CharingCross_Gall_2,CharingCross_Gall_3,CharingCross_Gall_4,
CharingCross_Gall_6,Freemasons_One,Freemasons_Two,Freemasons_Three,DyalSinghMansion_Old,DyalSinghMansion_Now,DyalSinghMansion_Gall_1,DyalSinghMansion_Gall_2,PunjabAssembly_Old,PunjabAssembly_Now,PunjabAssembly_Gall_1,PunjabAssembly_Gall_2,PunjabAssembly_Gall_3,
GovernorHouse_Old,GovernorHouse_Now,GovernorHouse_Gall_1,GovernorHouse_Gall_2,GovernorHouse_Gall_3,GovernorHouse_Gall_4,GovernorHouse_Gall_6,NCA_Old,NCA_Now,NCA_Gall_1,NCA_Gall_2,NCA_Gall_3,NCA_Gall_4,Bano,Kim,LambiSarak,Overcoat,
advertisement_Gallery1,advertisement_Gallery2,advertisement_Gallery3,advertisement_Gallery4,advertisement_Gallery5,advertisement_Gallery6,places_Gallery1,places_Gallery2,places_Gallery3,places_Gallery4,places_Gallery5,places_Gallery6,places_Gallery7,places_Gallery8,places_Gallery9,places_Gallery10,
places_Gallery11,places_Gallery12,places_Gallery13,places_Gallery14,places_Gallery15,places_Gallery16,places_Gallery17,places_Gallery18,places_Gallery19,places_Gallery20,places_Gallery21,general_Gallery1,general_Gallery2,general_Gallery3,general_Gallery4,general_Gallery5,general_Gallery6,general_Gallery7,
general_Gallery8,general_Gallery9,general_Gallery10,general_Gallery11,painting_Gallery1,painting_Gallery2,stamp_Gallery1,stamp_Gallery2,main,political,twomurders,mallroad,literary,hindu, mapBackground, poem_Gallery1, narration_Gallery1, narration_Gallery2];


const slideMap = {
  "home" : {
    name : "The Mall: History and Culture, Now and Then",
    slides : {
      "home" : {
        component : (
          <Slide bgImage={ProjectTitleBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addParallaxAndFadeRef(10)}>
                  <div className={slideStyles.slideContent}>
                    <ProjectTitle
                      title="The Mall"
                      subTitle = "History and Culture, Now and Then"
                      description={<span>An audio-visual experience exploring the history of the most prominent thoroughfare in Lahore</span>}
                    />
                  </div>
                </div>
              )}}
          </Slide>
        ),
        prev: "home",
        next: "themes",
        menuInverted : false,
        hideChapterNumber: true,
        hideVerticalNav: true,
        hideBottomBar: true,
      },
      "themes" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addParallaxAndFadeRef(10)}>
                  <Themes
                    themes={[{theme: 'Illustrated Map', linkTo: 'map'}, {theme: 'Literary Journeys', linkTo: 'journeys'}, {theme: 'Gallery', linkTo: 'gallery'}]}
                    images={[{image: mapBg, id: 'map'}, { image: literatureBg, id: 'journeys'}, { image: galleryBg, id: 'gallery'}]}
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "home",
        next : "credits",
        menuInverted : true,
        hideChapterNumber: false,
        hideVerticalNav: false,
      },
      "credits" : {
        component : (
          <Slide bgImage={ProjectCreditsBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addParallaxAndFadeRef(10)}>
                  <div className={slideStyles.slideContent}>
                    <ProjectCredits
                      disclaimer=<span>These projects are based on research conducted by students for the course <i>Walking in the City: Mapping Everyday Life in Lahore.</i></span>
                      projectName="The Mall: History and Culture, Now and Then"
                      studentNames="Nayyab Naveed, Aisha Zaman, Amal Zahra, Maahliqa Mehrissa Qureshi, Maryam Jamil, Rabia Tufail and Zoya Wasif"
                      supervisor={{name: 'Dr Ali Usman Qasmi', desig: 'Associate Professor (History), Department of Humanities and Social Sciences, LUMS'}}
                    />
                  </div>
                </div>
              )}}
          </Slide>
        ),
        prev : "themes",
        next : "credits",
        menuInverted : true,
        hideChapterNumber: true,
        bottomBarMessage: '',
        hideVerticalNav: true
      },
      "map" : {
        component : (
          <Slide bgImage={MapSolidBg}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <Map/>
                  <div className={slideStyles.map_click_prompt}><p>Click on a landmark to continue</p></div>
                </div>
              )}}
          </Slide>
        ),
        prev : "map",
        next : "map",
        menuInverted : false,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Illustration by Nayyab Naveed',
        showThemeButton: true,
        hideBottomBarScroll: true,
      },
      "aitchison" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Aitchison College" audioDesc desc=<span>Narration source: Muhammad Saeed - <i>Lahore: A Memoir</i></span>
                    />
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                            <CrossFadeImages images={{then: Aitchison_Old, now: Aitchison_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                            <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                              <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Then</p>
                              </div>
                              <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Now</p>
                              </div>
                            </div>
                          </div>
                        </Layout>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Aitchison College" className={classNames(imageStyles.hover_effect)} src={Aitchison_Gall_3}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Aitchison College" className={classNames(imageStyles.hover_effect)} src={Aitchison_Gall_4}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="Aitchison College" className={classNames(imageStyles.hover_effect)} src={Aitchison_Gall_2}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",5])}>
                            <img alt="Aitchison College" className={classNames(imageStyles.hover_effect)} src={Aitchison_Gall_5}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",6])}>
                            <img alt="Aitchison College" className={classNames(imageStyles.hover_effect)} src={Aitchison_Gall_1}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Aitchison College c. 1910s</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Aitchison College" src={Aitchison_Old} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Aitchison College</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Aitchison College" src={Aitchison_Now} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Aitchison College c. 1900s</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Aitchison College" src={Aitchison_Gall_3} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '62%', marginLeft: '19%'}}></img>,
                        },
                        {
                          description : <span>Aitchison College c. 1920</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Aitchison College" src={Aitchison_Gall_4} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Aitchison College Old Building (the album of Private J W Linley 1923-1938)</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Aitchison College" src={Aitchison_Gall_2} style={window.innerHeight > 675 ? {width: '90%', marginLeft: '5%'} : {width: '80%', marginLeft: '10%'}}></img>,
                        },
                        {
                          description : <span>Stamp celebrating the centenary of Aitchison College</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Aitchison College" src={Aitchison_Gall_5} style={window.innerHeight > 675 ? {width: '65%', marginLeft: '17.5%'} : {width: '55%', marginLeft: '22.5%'}}></img>,
                        },
                        {
                          description : <span>A painting of Aitchison College</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Aitchison College" src={Aitchison_Gall_1} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "aitchison",
        next : "aitchison",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        bottomBarAudio: aitchison_audio,
        showMapButton: true,
      },
      "zamzamah" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Zamzamah Cannon" audioDesc desc = <span>Narration source: Rudyard Kipling - <i>Kim</i></span>
                    />
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                            <CrossFadeImages images={{then: Zamzama_Old, now: Zamzama_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                            <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                              <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Then</p>
                              </div>
                              <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Now</p>
                              </div>
                            </div>
                          </div>
                        </Layout>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Zamzamah" className={classNames(imageStyles.hover_effect)} src={Zamzama_Gall_1}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Zamzamah" className={classNames(imageStyles.hover_effect)} src={Zamzama_Gall_2}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="Zamzamah" className={classNames(imageStyles.hover_effect)} src={Zamzama_Gall_3}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",5])}>
                            <img alt="Zamzamah" className={classNames(imageStyles.hover_effect)} src={Zamzama_Gall_4}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",6])}>
                            <img alt="Zamzamah" className={classNames(imageStyles.hover_effect)} src={Zamzama_Gall_5}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",7])}>
                            <img alt="Zamzamah" className={classNames(imageStyles.hover_effect)} src={Zamzama_Gall_6}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",8])}>
                            <img alt="Zamzamah" className={classNames(imageStyles.hover_effect)} src={Zamzama_Gall_7}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Zamzamah Cannon c. 1920</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Zamzamah" src={Zamzama_Old} style={window.innerHeight > 675 ? {width: '90%', marginLeft: '5%'} : {width: '80%', marginLeft: '10%'}}></img>,
                        },
                        {
                          description : <span>Zamzamah Cannon</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Zamzamah" src={Zamzama_Now} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Zamzamah Cannon (Ricalton, Jones, 1903)</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Zamzamah" src={Zamzama_Gall_1} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Zamzamah Cannon in front of University Hall c. 1910</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Zamzamah" src={Zamzama_Gall_2} style={window.innerHeight > 675 ? {width: '90%', marginLeft: '5%'} : {width: '80%', marginLeft: '10%'}}></img>,
                        },
                        {
                          description : <span>Zamzamah Cannon c. 1940s</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Zamzamah" src={Zamzama_Gall_3} style={window.innerHeight > 675 ? {width: '75%', marginLeft: '12.5%'} : {width: '65%', marginLeft: '17.5%'}}></img>,
                        },
                        {
                          description : <span>Zamzamah Cannon (closeup of plaque) c. 1946</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Zamzamah" src={Zamzama_Gall_4} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : <span>Zamzamah Cannon c. 1960</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Zamzamah" src={Zamzama_Gall_5} style={window.innerHeight > 675 ? {width: '50%', marginLeft: '25%'} : {width: '40%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : <span>Zamzamah Cannon c. 1970s</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Zamzamah" src={Zamzama_Gall_6} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Zamzamah Cannon stamp</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Zamzamah" src={Zamzama_Gall_7} style={window.innerHeight > 675 ? {width: '65%', marginLeft: '17.5%'} : {width: '55%', marginLeft: '22.5%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "zamzamah",
        next : "zamzamah",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        bottomBarAudio: Zamzama_audio,
        showMapButton: true,
      },
      "punjablibrary" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Punjab Public Library" audioDesc desc=<span>Narration source: Muhammad Saeed - <i>Lahore: A Memoir</i></span>
                    />
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                            <CrossFadeImages images={{then: PPL_Old, now: PPL_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                            <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                              <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Then</p>
                              </div>
                              <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Now</p>
                              </div>
                            </div>
                          </div>
                        </Layout>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Punjab Public Library" className={classNames(imageStyles.hover_effect)} src={PPL_Gall_3}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Punjab Public Library" className={classNames(imageStyles.hover_effect)} src={PPL_Gall_1}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="Punjab Public Library" className={classNames(imageStyles.hover_effect)} src={PPL_Gall_2}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Punjab Public Library</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Punjab Public Library" src={PPL_Old} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Punjab Public Library</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Punjab Public Library" src={PPL_Now} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Punjab Public library c. 1870</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Punjab Public Library" src={PPL_Gall_3} style={window.innerHeight > 675 ? {width: '85%', marginLeft: '7.5%'} : {width: '75%', marginLeft: '12.5%'}}></img>,
                        },
                        {
                          description : <span>Punjab Public Library 1920</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Punjab Public Library" src={PPL_Gall_1} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Punjab Public Library c. 1938</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Punjab Public Library" src={PPL_Gall_2} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "punjablibrary",
        next : "punjablibrary",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        bottomBarAudio: PPL_audio,
        showMapButton: true,
      },
      "freemasons" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Freemason's Lodge" audioDesc desc=<span>Narration source: Muhammad Saeed - <i>Lahore: A Memoir</i></span>/>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <Layout fixed_width layoutClassName="layout_flexed">
                      <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_33, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div id={imageStyles.Freemasons_One} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                          <img src={Freemasons_One} alt="Freemasons Lodge Plaque" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                      <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_33, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div id={imageStyles.Freemasons_Two} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                          <img src={Freemasons_Two} alt="Freemasons Lodge" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                      <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_33, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div id={imageStyles.Freemasons_Three} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                          <img src={Freemasons_Three} alt="Freemasons Lodge Painting" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                    </Layout>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Freemasons Hall Plaque</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Freemasons Hall" src={Freemasons_One} style={window.innerHeight > 675 ? {width: '45%', marginLeft: '27.5%'} : {width: '40%', marginLeft: '30%'}}></img>,
                        },
                        {
                          description : <span>Freemasons Hall</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Freemasons Hall" src={Freemasons_Two} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>A painting of the Freemasons Hall</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Freemasons Hall" src={Freemasons_Three} style={window.innerHeight > 675 ? {width: '75%', marginLeft: '12.5%'} : {width: '65%', marginLeft: '17.5%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "freemasons",
        next : "freemasons",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        bottomBarAudio: masonic_audio,
        showMapButton: true,
      },
      "tollington" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Tollington Market"
                    />
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                            <CrossFadeImages images={{then: Tollinton_Old, now: Tollinton_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                            <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                              <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Then</p>
                              </div>
                              <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Now</p>
                              </div>
                            </div>
                          </div>
                        </Layout>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Tollington Market" className={classNames(imageStyles.hover_effect)} src={Tollinton_Gall_8}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Tollington Market" className={classNames(imageStyles.hover_effect)} src={Tollinton_Gall_4}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="Tollington Market" className={classNames(imageStyles.hover_effect)} src={Tollinton_Gall_1}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",5])}>
                            <img alt="Tollington Market" className={classNames(imageStyles.hover_effect)} src={Tollinton_Gall_3}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",6])}>
                            <img alt="Tollington Market" className={classNames(imageStyles.hover_effect)} src={Tollinton_Gall_5}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",7])}>
                            <img alt="Tollington Market" className={classNames(imageStyles.hover_effect)} src={Tollinton_Gall_6}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",8])}>
                            <img alt="Tollington Market" className={classNames(imageStyles.hover_effect)} src={Tollinton_Gall_9}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Tollington Market c. 1907</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Tollington Market" src={Tollinton_Old} style={window.innerHeight > 675 ? {width: '90%', marginLeft: '5%'} : {width: '80%', marginLeft: '10%'}}></img>,
                        },
                        {
                          description : <span>Tollington Market</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Tollington Market" src={Tollinton_Now} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Tollington Market under construction c. 1863</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Tollington Market" src={Tollinton_Gall_8} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Tollington Market or Opening of the Punjab Exhibition of Arts and Industry at Lahore, from Illustrated London News, 1864</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Tollington Market" src={Tollinton_Gall_4} style={window.innerHeight > 675 ? {width: '75%', marginLeft: '12.5%'} : {width: '65%', marginLeft: '17.5%'}}></img>,
                        },
                        {
                          description : <span>Poster of Punjab Industrial Exhibition aka Tollington Market c. 1893</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Tollington Market" src={Tollinton_Gall_1} style={window.innerHeight > 675 ? {width: '50%', marginLeft: '25%'} : {width: '40%', marginLeft: '30%'}}></img>,
                        },
                        {
                          description : <span>Tollington Market, or Inside View of the Exhibition Building</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Tollington Market" src={Tollinton_Gall_3} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : <span>Tollington Market, The Mall</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Tollington Market" src={Tollinton_Gall_5} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : <span>Tollington Market and Railway Building Labor Returns</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Tollington Market" src={Tollinton_Gall_6} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '50%', marginLeft: '25%'}}></img>,
                        },
                        {
                          description : <span>A painting of the Tollington Market</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Tollington Market" src={Tollinton_Gall_9} style={window.innerHeight > 675 ? {width: '65%', marginLeft: '17.5%'} : {width: '55%', marginLeft: '22.5%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "tollington",
        next : "tollington",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        showMapButton: true,
      },
      "anarkali" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Anarkali" audioDesc desc = <span>Narration source: Saadat Hasan Manto - <i>Naya Qanoon</i></span>
                    />
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                            <CrossFadeImages images={{then: Anarkali_Old, now: Anarkali_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                            <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                              <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Then</p>
                              </div>
                              <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Now</p>
                              </div>
                            </div>
                          </div>
                        </Layout>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Anarkali" className={classNames(imageStyles.hover_effect)} src={Anarkali_Gall_6}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Anarkali" className={classNames(imageStyles.hover_effect)} src={Anarkali_Gall_5}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="Anarkali" className={classNames(imageStyles.hover_effect)} src={Anarkali_Gall_1}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",5])}>
                            <img alt="Anarkali" className={classNames(imageStyles.hover_effect)} src={Anarkali_Gall_2}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",6])}>
                            <img alt="Anarkali" className={classNames(imageStyles.hover_effect)} src={Anarkali_Gall_3}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Anarkali Street</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Anarkali" src={Anarkali_Old} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Anarkali Street</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Anarkali" src={Anarkali_Now} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>An old advertisement of a <i>saree</i> vendor in Anarkali</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Anarkali" src={Anarkali_Gall_6} style={window.innerHeight > 675 ? {width: '50%', marginLeft: '25%'} : {width: '40%', marginLeft: '30%'}}></img>,
                        },
                        {
                          description : <span>Anarkali Market c. 1980</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Anarkali" src={Anarkali_Gall_5} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : <span>A painting of Anarkali Market</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Anarkali" src={Anarkali_Gall_1} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>An artist's impression of Anarkali Market</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Anarkali" src={Anarkali_Gall_2} style={window.innerHeight > 675 ? {width: '40%', marginLeft: '30%'} : {width: '35%', marginLeft: '32.5%'}}></img>,
                        },
                        {
                          description : <span>A painting of Anarkali Market</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Anarkali" src={Anarkali_Gall_3} style={window.innerHeight > 675 ? {width: '40%', marginLeft: '30%'} : {width: '35%', marginLeft: '32.5%'}}></img>,
                        },
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "anarkali",
        next : "anarkali",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        bottomBarAudio: anarkali_audio,
        showMapButton: true,
      },
      "gpo" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="General Post Office (GPO)" audioDesc desc = <span>Narration source: Colonel H.R Goulding - <i>Reminiscences of a Resident</i></span>
                    />
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                            <CrossFadeImages images={{then: GPO_Old, now: GPO_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                            <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                              <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Then</p>
                              </div>
                              <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Now</p>
                              </div>
                            </div>
                          </div>
                        </Layout>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="GPO" className={classNames(imageStyles.hover_effect)} src={GPO_Gall_1}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="GPO" className={classNames(imageStyles.hover_effect)} src={GPO_Gall_3}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="GPO" className={classNames(imageStyles.hover_effect)} src={GPO_Gall_4}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",5])}>
                            <img alt="GPO" className={classNames(imageStyles.hover_effect)} src={GPO_Gall_12}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",6])}>
                            <img alt="GPO" className={classNames(imageStyles.hover_effect)} src={GPO_Gall_9}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",7])}>
                            <img alt="GPO" className={classNames(imageStyles.hover_effect)} src={GPO_Gall_11}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Lahore General Post Office c. 1910s</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="GPO" src={GPO_Old} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Lahore General Post Office</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="GPO" src={GPO_Now} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>General Post Office c. 1910s</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="GPO" src={GPO_Gall_1} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>General Post Office c. 1910s</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="GPO" src={GPO_Gall_3} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>General Post Office postcard c. 1964</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="GPO" src={GPO_Gall_4} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>General Post Office on a postage stamp</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="GPO" src={GPO_Gall_12} style={window.innerHeight > 675 ? {width: '50%', marginLeft: '25%'} : {width: '40%', marginLeft: '30%'}}></img>,
                        },
                        {
                          description : <span>A painting of the General Post Office</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="GPO" src={GPO_Gall_9} style={window.innerHeight > 675 ? {width: '75%', marginLeft: '12.5%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : <span>An artist's impression of the General Post Office</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="GPO" src={GPO_Gall_11} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '50%', marginLeft: '25%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "gpo",
        next : "gpo",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        bottomBarAudio: GPO_audio,
        showMapButton: true,
      },
      "highcourt" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Lahore High Court" audioDesc desc=<span>Narration source: Muhammad Saeed - <i>Lahore: A Memoir</i></span>
                    />
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                            <CrossFadeImages images={{then: HighCourt_Old, now: HighCourt_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                            <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                              <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Then</p>
                              </div>
                              <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Now</p>
                              </div>
                            </div>
                          </div>
                        </Layout>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Lahore High Court" className={classNames(imageStyles.hover_effect)} src={HighCourt_Gall_1}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Lahore High Court" className={classNames(imageStyles.hover_effect)} src={HighCourt_Gall_19}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="Lahore High Court" className={classNames(imageStyles.hover_effect)} src={HighCourt_Gall_7}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",5])}>
                            <img alt="Lahore High Court" className={classNames(imageStyles.hover_effect)} src={HighCourt_Gall_4}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",6])}>
                            <img alt="Lahore High Court" className={classNames(imageStyles.hover_effect)} src={HighCourt_Gall_12}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",7])}>
                            <img alt="Lahore High Court" className={classNames(imageStyles.hover_effect)} src={HighCourt_Gall_10}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",8])}>
                            <img alt="Lahore High Court" className={classNames(imageStyles.hover_effect)} src={HighCourt_Gall_8}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",9])}>
                            <img alt="Lahore High Court" className={classNames(imageStyles.hover_effect)} src={HighCourt_Gall_5}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",10])}>
                            <img alt="Lahore High Court" className={classNames(imageStyles.hover_effect)} src={HighCourt_Gall_17}/>
                          </div>
                        </div>

                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Lahore High court c. 1940s</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore High Court" src={HighCourt_Old} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Lahore High Court</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore High Court" src={HighCourt_Now} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>John Lawrence statue (in front of High Court) c. 1910s</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_1} style={window.innerHeight > 675 ? {width: '40%', marginLeft: '30%'} : {width: '30%', marginLeft: '35%'}}></img>,
                        },
                        {
                          description : <span>Lawrence's Statue in front of the High Court</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_19} style={window.innerHeight > 675 ? {width: '50%', marginLeft: '25%'} : {width: '40%', marginLeft: '30%'}}></img>,
                        },
                        {
                          description : <span>Lahore High court, an album photo, c. 1880s</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_7} style={window.innerHeight > 675 ? {width: '75%', marginLeft: '12.5%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : <span>Lahore High Court c. 1908</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_4} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Lahore High Court c. 1925</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_12} style={window.innerHeight > 675 ? {width: '75%', marginLeft: '12.5%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : <span>Lahore High Court Bar Association Library c. 1933</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_10} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Lahore High Court</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_8} style={window.innerHeight > 675 ? {width: '75%', marginLeft: '12.5%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : <span>Lahore High court c. 1960s</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_5} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Stamps celebrating 150 years of the Lahore High Court</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_17} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "highcourt",
        next : "highcourt",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        bottomBarAudio: high_court_audio,
        showMapButton: true,
      },
      "ymca" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="YMCA" audioDesc desc=<span>Narration source: Muhammad Saeed - <i>Lahore: A Memoir</i></span>
                    />
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                            <CrossFadeImages images={{then: YMCA_Old, now: YMCA_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                            <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                              <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Then</p>
                              </div>
                              <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Now</p>
                              </div>
                            </div>
                          </div>
                        </Layout>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>YMCA c. 1920</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="YMCA" src={YMCA_Old} style={window.innerHeight > 675 ? {width: '90%', marginLeft: '5%'} : {width: '80%', marginLeft: '10%'}}></img>,
                        },
                        {
                          description : <span>YMCA</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="YMCA" src={YMCA_Now} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "ymca",
        next : "ymca",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        bottomBarAudio: YMCA_audio,
        showMapButton: true,
      },
      "gangaram" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Ganga Ram Trust Building" audioDesc desc=<span>Narration source: Muhammad Saeed - <i>Lahore: A Memoir</i></span>
                    />
                  </div>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                        <div id={imageStyles.gangaRam_Trust} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                          <img src={GangaRamTrust_Now} className={imageStyles.hover_effect}/>
                        </div>
                      </div>
                    </Layout>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Ganga Ram Building</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Ganga Ram Building" src={GangaRamTrust_Now} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "gangaram",
        next : "gangaram",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        bottomBarAudio: ganga_ram_audio,
        showMapButton: true,
      },
      "alhamra" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Alhamra Arts Council"
                    />
                  </div>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                        <div id={imageStyles.alhamra} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                          <img src={AlhamraArt} className={imageStyles.hover_effect}/>
                        </div>
                      </div>
                    </Layout>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Alhamra Arts Center</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Alhamra Arts Center" src={AlhamraArt} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "alhamra",
        next : "alhamra",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        showMapButton: true,
      },
      "charingcross" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Charing Cross"
                    />
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                            <CrossFadeImages images={{then: CharingCross_Old, now: CharingCross_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                            <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                              <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Then</p>
                              </div>
                              <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Now</p>
                              </div>
                            </div>
                          </div>
                        </Layout>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Charing Cross" className={classNames(imageStyles.hover_effect)} src={CharingCross_Gall_6}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Charing Cross" className={classNames(imageStyles.hover_effect)} src={CharingCross_Gall_3}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="Charing Cross" className={classNames(imageStyles.hover_effect)} src={CharingCross_Gall_1}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",5])}>
                            <img alt="Charing Cross" className={classNames(imageStyles.hover_effect)} src={CharingCross_Gall_7}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",6])}>
                            <img alt="Charing Cross" className={classNames(imageStyles.hover_effect)} src={CharingCross_Gall_4}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",7])}>
                            <img alt="Charing Cross" className={classNames(imageStyles.hover_effect)} src={CharingCross_Gall_2}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Charing Cross Pavillion c. 1910s with Queen Victoria's statue</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Charing Cross" src={CharingCross_Old} style={window.innerHeight > 675 ? {width: '85%', marginLeft: '7.5%'} : {width: '75%', marginLeft: '12.5%'}}></img>,
                        },
                        {
                          description : <span>Charing Cross. Queen Victoria's statue has been replaced by a replica of the Quran</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Charing Cross" src={CharingCross_Now} style={window.innerHeight > 675 ? {width: '85%', marginLeft: '7.5%'} : {width: '70%', marginLeft: '12.5%'}}></img>,
                        },
                        {
                          description : <span>Charing Cross Pavillion installation ceremony of Victoria's statue</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Charing Cross" src={CharingCross_Gall_6} style={window.innerHeight > 675 ? {width: '75%', marginLeft: '12.5%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : <span>Charing Cross Pavillion (the album of Private J W Linley 1923-1938)</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Charing Cross" src={CharingCross_Gall_3} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Charing Cross c. 1930s</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Charing Cross" src={CharingCross_Gall_1} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Queen Victoria's statue being transported from Charing Cross to Lahore Museum</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Charing Cross" src={CharingCross_Gall_7} style={window.innerHeight > 675 ? {width: '75%', marginLeft: '12.5%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : <span>Charing cross Pavillion c. 1960s. Queen Victoria' Statue has been removed</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Charing Cross" src={CharingCross_Gall_4} style={window.innerHeight > 675 ? {width: '85%', marginLeft: '7.5%'} : {width: '80%', marginLeft: '10%'}}></img>,
                        },
                        {
                          description : <span>Charing Cross c. 1973</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Charing Cross" src={CharingCross_Gall_2} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "charingcross",
        next : "charingcross",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        showMapButton: true,
      },
      "dyalsingh" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Dyal Singh Mansion" audioDesc desc=<span>Narration source: Muhammad Saeed - <i>Lahore: A Memoir</i></span>
                    />
                    <div className={slideStyles.galleryChevrons_container}>
                      <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                      <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                      <div onClick={props.moveForward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                    </div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                            <CrossFadeImages images={{then: DyalSinghMansion_Old, now: DyalSinghMansion_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                            <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                              <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Then</p>
                              </div>
                              <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Now</p>
                              </div>
                            </div>
                          </div>
                        </Layout>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Dyal Singh Mansion" className={classNames(imageStyles.hover_effect)} src={DyalSinghMansion_Gall_2}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Dyal Singh Mansion" className={classNames(imageStyles.hover_effect)} src={DyalSinghMansion_Gall_1}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Dyal Singh Mansion</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Dyal Singh Mansion" src={DyalSinghMansion_Old} style={window.innerHeight > 675 ? {width: '85%', marginLeft: '7.5%'} : {width: '75%', marginLeft: '12.5%'}}></img>,
                        },
                        {
                          description : <span>Dyal Singh Mansion</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Dyal Singh Mansion" src={DyalSinghMansion_Now} style={window.innerHeight > 675 ? {width: '85%', marginLeft: '7.5%'} : {width: '75%', marginLeft: '12.5%'}}></img>,
                        },
                        {
                          description : <span>Dyal Singh Building c. 1930s</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Dyal Singh Mansion" src={DyalSinghMansion_Gall_2} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Dyal Singh Building c. 1959</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Dyal Singh Mansion" src={DyalSinghMansion_Gall_1} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "dyalsingh",
        next : "dyalsingh",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        bottomBarAudio: dyal_singh_audio,
        showMapButton: true,
      },
      "punjabassembly" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Punjab Assembly"
                    />
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                            <CrossFadeImages images={{then: PunjabAssembly_Old, now: PunjabAssembly_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                            <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                              <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Then</p>
                              </div>
                              <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Now</p>
                              </div>
                            </div>
                          </div>
                        </Layout>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Punjab Assembly" className={classNames(imageStyles.hover_effect)} src={PunjabAssembly_Gall_1}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Punjab Assembly" className={classNames(imageStyles.hover_effect)} src={PunjabAssembly_Gall_2}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="Punjab Assembly" className={classNames(imageStyles.hover_effect)} src={PunjabAssembly_Gall_3}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Punjab Assembly Hall c. 1940s</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Punjab Assembly" src={PunjabAssembly_Old} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Punjab Assembly</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Punjab Assembly" src={PunjabAssembly_Now} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Punjab Assembly Hall c. 1940s</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Punjab Assembly" src={PunjabAssembly_Gall_1} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Punjab Assembly Hall c. 1940s</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Punjab Assembly" src={PunjabAssembly_Gall_2} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>A painter's impression of the Punjab Assembly Hall</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Punjab Assembly" src={PunjabAssembly_Gall_3} style={window.innerHeight > 675 ? {width: '40%', marginLeft: '30%'} : {width: '35%', marginLeft: '32.5%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "punjabassembly",
        next : "punjabassembly",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        showMapButton: true,
      },
      "governorhouse" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Governor House" audioDesc desc = <span>Narration source: Pran Nevile - <i>Lahore: A Sentimental Journey</i></span>/>
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                            <CrossFadeImages images={{then: GovernorHouse_Old, now: GovernorHouse_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                            <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                              <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Then</p>
                              </div>
                              <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Now</p>
                              </div>
                            </div>
                          </div>
                        </Layout>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Governor House" className={classNames(imageStyles.hover_effect)} src={GovernorHouse_Gall_1}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Governor House" className={classNames(imageStyles.hover_effect)} src={GovernorHouse_Gall_2}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="Governor House" className={classNames(imageStyles.hover_effect)} src={GovernorHouse_Gall_3}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",5])}>
                            <img alt="Governor House" className={classNames(imageStyles.hover_effect)} src={GovernorHouse_Gall_4}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",6])}>
                            <img alt="Governor House" className={classNames(imageStyles.hover_effect)} src={GovernorHouse_Gall_6}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Government House c. 1875</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Governor House" src={GovernorHouse_Old} style={window.innerHeight > 675 ? {width: '85%', marginLeft: '7.5%'} : {width: '75%', marginLeft: '12.5%'}}></img>,
                        },{
                          description : <span>Governor House</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Governor House" src={GovernorHouse_Now} style={window.innerHeight > 675 ? {width: '90%', marginLeft: '5%'} : {width: '80%', marginLeft: '10%'}}></img>,
                        },
                        {
                          description : <span>Government house</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Governor House" src={GovernorHouse_Gall_1} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Government House, Lahore c. 1869</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Governor House" src={GovernorHouse_Gall_2} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Government House, Lahore c. 1910 (Postcard)</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Governor House" src={GovernorHouse_Gall_3} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '50%', marginLeft: '25%'}}></img>,
                        },
                        {
                          description : <span>Government House c.1910</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Governor House" src={GovernorHouse_Gall_4} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>An advertisement shows Ayub Khan watering a plant at the Government House</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="Governor House" src={GovernorHouse_Gall_6} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '50%', marginLeft: '25%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "governorhouse",
        next : "governorhouse",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        bottomBarAudio: government_audio,
        showMapButton: true,
      },
      "nca" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="National College of Arts (NCA)" audioDesc desc = <span>Narration source: Pran Nevile - <i>Lahore: A Sentimental Journey</i></span>
                    />
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                            <CrossFadeImages images={{then: NCA_Old, now: NCA_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                            <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                              <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Then</p>
                              </div>
                              <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Now</p>
                              </div>
                            </div>
                          </div>
                        </Layout>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="NCA" className={classNames(imageStyles.hover_effect)} src={NCA_Gall_3}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="NCA" className={classNames(imageStyles.hover_effect)} src={NCA_Gall_1}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="NCA" className={classNames(imageStyles.hover_effect)} src={NCA_Gall_2}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",5])}>
                            <img alt="NCA" className={classNames(imageStyles.hover_effect)} src={NCA_Gall_4}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Mayo School of Arts c. 1910s</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="NCA" src={NCA_Old} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>National College of Arts</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="NCA" src={NCA_Now} style={window.innerHeight > 675 ? {width: '85%', marginLeft: '7.5%'} : {width: '75%', marginLeft: '12.5%'}}></img>,
                        },
                        {
                          description : <span>Punjab Museum and Mayo School c. 1890</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="NCA" src={NCA_Gall_3} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '50%', marginLeft: '25%'}}></img>,
                        },
                        {
                          description : <span>Punjab Museum and Mayo School c. 1910</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="NCA" src={NCA_Gall_1} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Mayo School of Arts c. 1911</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="NCA" src={NCA_Gall_2} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : <span>Stamp celebrating 100 years of NCA</span>,
                          title : "",
                          source : "",
                          render : ()=> <img alt="NCA" src={NCA_Gall_4} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "nca",
        next : "nca",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        bottomBarAudio: NCA_audio,
        showMapButton: true,
      },
      "ghulamrasool" : {
        component : (
          <Slide bgImage={ProjectThemesBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Ghulam Rasool Building"
                    />
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_100, layoutStyles.align_center)}>
                            <CrossFadeImages images={{then: GhulamRasool_Old, now: GhulamRasool_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                            <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                              <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Then</p>
                              </div>
                              <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                                <p>Now</p>
                              </div>
                            </div>
                          </div>
                        </Layout>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : <span>Ghulam Rasool (Smith and Campbell 1922)</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Ghulam Rasool Building" src={GhulamRasool_Old} style={window.innerHeight > 675 ? {width: '85%', marginLeft: '7.5%'} : {width: '75%', marginLeft: '12.5%'}}></img>,
                        },
                        {
                          description : <span>Ghulam Rasool Building</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Ghulam Rasool Building" src={GhulamRasool_Now} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "ghulamrasool",
        next : "ghulamrasool",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Click images to enlarge',
        hideBottomBarScroll: true,
        showMapButton: true,
      },
      "journeys" : {
        component : (
          <Slide bgImage={literatureSlideBg}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Literary Journeys" desc="Short videos based on excerpts from famous literary pieces mentioning landmarks of the Mall"/>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_50, layoutStyles.align_end, layoutStyles.justify_center)}>
                        <VideoLink inverted setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["1",0]} image={LambiSarak} linkMessage="Krishan Chandar"/>
                        <VideoLink inverted setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["1",1]} image={Kim} linkMessage="Rudyard Kipling"/>
                      </div>
                      <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_50, layoutStyles.align_start, layoutStyles.justify_center)}>
                        <VideoLink inverted setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["1",2]} image={Overcoat} linkMessage="Ghulam Abbas"/>
                        <VideoLink inverted setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["1",3]} image={Bano} linkMessage="Bano Qudsia"/>
                      </div>
                    </Layout>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : <p>Dou Forlong Lambi Sarak - Krishan Chandar</p>,
                        title : "",
                        source : "",
                        render : ()=> <VideoFrame link='https://www.youtube.com/embed/lQEhkCbN9mg'/>,
                      },
                      {
                        description : <p>Kim - Rudyard Kipling</p>,
                        title : "",
                        source : "",
                        render : ()=> <VideoFrame link='https://www.youtube.com/embed/v1b65ZM1wfU'/>,
                      },
                      {
                        description : <p>Overcoat - Ghulam Abbas</p>,
                        title : "",
                        source : "",
                        render : ()=>  <VideoFrame link='https://www.youtube.com/embed/wkLVuGjcRSU'/>,
                      },
                      {
                        description : <p>Raja Gidh - Bano Qudsia</p>,
                        title : "",
                        source : "",
                        render : ()=>  <VideoFrame link='https://www.youtube.com/embed/nNPTK2K4W7Y'/>,
                      }]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "journeys",
        next : "journeys",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        bottomBarMessage: 'Select a video',
        hideBottomBarScroll: true,
        showThemeButton: true,
      },
      "gallery" : {
        component : (
          <Slide gallerySlide bgImage={gallerySlideBg}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addFadeRef}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Gallery"/>
                  </div>

                  <div className={slideStyles.galleryChevrons_container}>
                    {/*<p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p> */}
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}
                      scrollTiming={props.scrollTiming}>
                        <GallerySection
                          id="advertisement_section"
                          addFadeRef={props.addFadeRef}
                          setDisplayedOverlay={props.setDisplayedOverlay}
                          images = {{row1: [{image: advertisement_Gallery2, oId: ["1",0]}, {image: advertisement_Gallery3, oId: ["1",1]}, {image: advertisement_Gallery5, oId: ["1",2]}], row2: [{image: advertisement_Gallery4, oId: ["1",3]}, {image: GovernorHouse_Gall_6, oId: ["1",4]}], row3: [{image: advertisement_Gallery1, oId: ["1",5]}, {image: advertisement_Gallery6, oId: ["1",6]}, {image: advertisement_Gallery7, oId: ["1",7]}]}}>
                        </GallerySection>
                        <GallerySection
                          margined
                          id="places_section"
                          increased_row_padding
                          addFadeRef={props.addFadeRef}
                          setDisplayedOverlay={props.setDisplayedOverlay}
                          images = {{row1: [{image: places_Gallery1, oId: ["2",0]}, {image: places_Gallery2, oId: ["2",1]}, {image: places_Gallery3, oId: ["2",2]}, {image: places_Gallery4, oId: ["2",3]}, {image: places_Gallery5, oId: ["2",4]}, {image: places_Gallery6, oId: ["2",5]}, {image: places_Gallery21, oId: ["2",6]}], row2: [{image: places_Gallery8, oId: ["2",7]}, {image: places_Gallery9, oId: ["2",8]}, {image: places_Gallery10, oId: ["2",9]}, {image: places_Gallery11, oId: ["2",10]}, {image: places_Gallery12, oId: ["2",11]}, {image: places_Gallery13, oId: ["2",12]}, {image: places_Gallery14, oId: ["2",13]}], row3: [{image: places_Gallery15, oId: ["2",14]}, {image: places_Gallery16, oId: ["2",15]}, {image: places_Gallery17, oId: ["2",16]}, {image: places_Gallery18, oId: ["2",17]}, {image: places_Gallery19, oId: ["2",18]}, {image: places_Gallery20, oId: ["2",19]}, {image: places_Gallery7, oId: ["2",20]}]}}>
                        </GallerySection>
                        <div id="poem_section" className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33, slideStyles.margined_gallery)}>
                          <div className={classNames(imageStyles.full_gallery, imageStyles.full_gallery_increased_margin, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["6",0])}>
                            <img alt="Poem about Mall Road" className={classNames(imageStyles.hover_effect)} src={poem_Gallery1}/>
                          </div>
                        </div>
                        <GallerySection
                          margined
                          increased_row_padding
                          id="general_section"
                          addFadeRef={props.addFadeRef}
                          setDisplayedOverlay={props.setDisplayedOverlay}
                          images = {{row1: [{image: general_Gallery1, oId: ["3",0]}, {image: general_Gallery2, oId: ["3",1]}, {image: general_Gallery3, oId: ["3",2]}, {image: general_Gallery4, oId: ["3",3]}, {image: general_Gallery5, oId: ["3",4]}], row2: [{image: general_Gallery6, oId: ["3",5]}, {image: general_Gallery7, oId: ["3",6]}, {image: general_Gallery8, oId: ["3",7]}, {image: general_Gallery13, oId: ["3",8]}, {image: general_Gallery14, oId: ["3",9]}], row3: [{image: general_Gallery9, oId: ["3",10]}, {image: general_Gallery11, oId: ["3",11]}, {image: general_Gallery10, oId: ["3",12]}, {image: general_Gallery12, oId: ["3",13]}]}}>
                        </GallerySection>
                        <GallerySection
                          margined
                          id="painting_section"
                          addFadeRef={props.addFadeRef}
                          setDisplayedOverlay={props.setDisplayedOverlay}
                          images = {{row1: [{image: painting_Gallery1, oId: ["4",0]}], row2: [{image: painting_Gallery2, oId: ["4",1]}, {image: Anarkali_Gall_3, oId: ["4",2]}], row3: [{image: GPO_Gall_9, oId: ["4",3]}]}}>
                        </GallerySection>
                        <GallerySection
                          margined
                          id="stamp_section"
                          addFadeRef={props.addFadeRef}
                          images = {{row1: [{image: stamp_Gallery1, oId: ["5",0]}, {image: Aitchison_Gall_5, oId: ["5",1]}], row2: [{image: stamp_Gallery2, oId: ["5",2]}, {image: GPO_Gall_12, oId: ["5",3]}], row3: [{image: HighCourt_Gall_17, oId: ["5",4]}]}}
                          setDisplayedOverlay={props.setDisplayedOverlay}>
                        </GallerySection>
                        <GallerySection
                          margined
                          increased_row_padding
                          id="narration_section"
                          addFadeRef={props.addFadeRef}
                          images = {{row1: [{image: narration_Gallery1, oId: ["7",0]}, {image: narration_Gallery2, oId: ["7",1]}, {image: places_Gallery8, oId: ["7", 2]}], row2: [{image: places_Gallery6, oId: ["7",3]}, {image: places_Gallery4, oId: ["7",4]}], row3: [{image: places_Gallery5, oId: ["7",5]}, {image: HighCourt_Gall_19, oId: ["7",6]}]}}
                          setDisplayedOverlay={props.setDisplayedOverlay}>
                        </GallerySection>
                    </HorizontalScroll>

                    <div className={galleryNavStyles.gallery_navigation}>
                      <div className={galleryNavStyles.gallery_navItem}>
                        <p onClick={() => props.movetoSection('advertisement_section')} className={galleryNavStyles.gallery_navigation_title} style={props.gallerySec === 'advertisement_section' ? { color: '#fff' } : {color: '#FFEB3B'}}>Advertisements</p>
                      </div>
                      <div className={galleryNavStyles.gallery_navItem}>
                        <p onClick={() => props.movetoSection('places_section')} className={galleryNavStyles.gallery_navigation_title} style={props.gallerySec === 'places_section' ? { color: '#fff' } : { color: '#FFEB3B'}}>Places</p>
                      </div>
                      <div className={galleryNavStyles.gallery_navItem}>
                        <p onClick={() => props.movetoSection('poem_section')} className={galleryNavStyles.gallery_navigation_title} style={props.gallerySec === 'poem_section' ? { color: '#fff' } : { color: '#FFEB3B'}}>Poetry</p>
                      </div>
                      <div className={galleryNavStyles.gallery_navItem}>
                        <p onClick={() => props.movetoSection('general_section')} className={galleryNavStyles.gallery_navigation_title} style={props.gallerySec === 'general_section' ? { color: '#fff' } : { color: '#FFEB3B'}}>General</p>
                      </div>
                      <div className={galleryNavStyles.gallery_navItem}>
                        <p onClick={() => props.movetoSection('painting_section')} className={galleryNavStyles.gallery_navigation_title} style={props.gallerySec === 'painting_section' ? { color: '#fff' } : { color: '#FFEB3B'}}>Paintings</p>
                      </div>
                      <div className={galleryNavStyles.gallery_navItem}>
                        <p onClick={() => props.movetoSection('stamp_section')} className={galleryNavStyles.gallery_navigation_title} style={props.gallerySec === 'stamp_section' ? { color: '#fff' } : { color: '#FFEB3B'}}>Stamps</p>
                      </div>
                      <div className={galleryNavStyles.gallery_navItem}>
                        <p onClick={() => props.movetoSection('narration_section')} className={galleryNavStyles.gallery_navigation_title} style={props.gallerySec === 'narration_section' ? { color: '#fff' } : { color: '#FFEB3B'}}>Narrations</p>
                      </div>

                      <div className={galleryNavStyles.backtoMapButton_container}>
                        <Fade bottom duration={500} distance={'20px'}>
                          <Link to="/themes" style={{textDecoration: 'none', color: 'inherit'}}>
                            <p className={`${galleryNavStyles.backtoMap_button} ${galleryNavStyles.backtoMap_inverted}`}>Back to Themes</p>
                          </Link>
                        </Fade>
                      </div>
                    </div>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : "An illustrated guide to the Lahore Museum published in 1908",
                          title : "",
                          source : "",
                          render : ()=> <img alt="Lahore Museum" src={advertisement_Gallery2} style={window.innerHeight > 675 ? {width: '40%', marginLeft: '30%'} : {width: '35%', marginLeft: '32.5%'}}></img>,
                        },
                        {
                          description : "A 1917 poster for an exhibition of craft works in Central Museum, Lahore",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore Museum" src={advertisement_Gallery3} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '50%', marginLeft: '25%'}}></img>,
                        },
                        {
                          description : "An 1893 poster of The Punjab Industrial Exhibition held at Tollington Market and Lahore Museum",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Tollington Market" src={advertisement_Gallery5} style={window.innerHeight > 675 ? {width: '50%', marginLeft: '25%'} : {width: '40%', marginLeft: '30%'}}></img>,
                        },
                        {
                          description : "A poster for an exhibition commemorating Rembrandt, sponsored by Mayo School of Arts (1957)",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Mayo School of Arts" src={advertisement_Gallery4} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '90%', marginLeft: '5%'}}></img>,
                        },
                        {
                          description : <span>An advertisement shows Ayub Khan watering a plant at the Government House</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Government House Ad" src={GovernorHouse_Gall_6} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : <span>A poster by the Capitol Cinema on Mcloed Road for the sreening of a 1931 talkie film <i>Alam-ara</i></span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Alhamra" src={advertisement_Gallery1} style={window.innerHeight > 675 ? {width: '40%', marginLeft: '30%'} : {width: '35%', marginLeft: '32.5%'}}></img>,
                        },
                        {
                          description : "A 1910 poster for a drama performed by The Mayo School of Art's Dramatic Club",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Mayo School of Arts" src={advertisement_Gallery6} style={window.innerHeight > 675 ? {width: '40%', marginLeft: '30%'} : {width: '35%', marginLeft: '32.5%'}}></img>,
                        },
                        {
                          description : "A 1930 advertisement of a soap manufacturer",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Soap Advertisement" src={advertisement_Gallery7} style={window.innerHeight > 675 ? {width: '40%', marginLeft: '30%'} : {width: '35%', marginLeft: '32.5%'}}></img>,
                        }
                      ]
                    }
                  />
                  <Overlay
                    oId="2"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : "The Cathedral (Vintage Postcard)",
                          title : "",
                          source : "",
                          render : ()=> <img alt="Roman Cathedral, Lahore" src={places_Gallery1} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "The Cathedral c. 1880",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Roman Cathedral, Lahore" src={places_Gallery2} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Lawrence Hall - Lahore Anglican Synod (1890 - 1895)",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lawrence Hall" src={places_Gallery3} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Lawrence Hall - published in Illustrated London News 1864",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Montgomery Hall" src={places_Gallery4} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Montgomery Hall c. 1890s",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Montgomery Hall" src={places_Gallery5} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Montgomery Hall c. 1910s",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Montgomery Hall" src={places_Gallery6} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Zoo Plaque (Original Aviary)",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Aviary, Lahore Zoo" src={places_Gallery21} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Lahore Museum Postcard",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore Museum" src={places_Gallery8} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Artisans at work at The Mayo School of Arts c. 1900s",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Mayo School of Arts" src={places_Gallery9} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Artisans at work at The Mayo School of Arts c. 1935",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Mayo School of Arts" src={places_Gallery10} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Artisans at work at The Mayo School of Arts c. 1907",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Mayo School of Arts" src={places_Gallery11} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Artisans at the Mayo School of Arts working on a model of The Sacred Heart Cathedral Lahore (1910)",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Mayo School of Arts" src={places_Gallery12} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Regal Chowk c. 1960s",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="The Mall" src={places_Gallery13} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Government Telegraph Office, Lahore",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Government Telegraph Office, Lahore" src={places_Gallery14} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Telegraph Office and Mayo Hospital c. 1890",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Telegraph Office and Mayo Hospital" src={places_Gallery15} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Municipal (Town) Hall, Lahore c. 1890",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Municipal Hall, Lahore" src={places_Gallery16} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Municipal (Town) Hall, Lahore",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Municipal Hall, Lahore" src={places_Gallery17} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Municipal (Town) Hall, Lahore c. 1900s",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Municipal Hall, Lahore" src={places_Gallery18} style={window.innerHeight > 675 ? {width: '90%', marginLeft: '5%'} : {width: '80%', marginLeft: '10%'}}></img>,
                        },
                        {
                          description : "Punjab University Hall c. 1920",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="University Hall" src={places_Gallery19} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Zoological Gardens c. 1940",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore Zoo" src={places_Gallery20} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Lahore Museum",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore Museum" src={places_Gallery7} style={window.innerHeight > 675 ? {width: '50%', marginLeft: '25%'} : {width: '40%', marginLeft: '30%'}}></img>,
                        }
                      ]
                    }
                  />
                  <Overlay
                    oId="3"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : "The Mall c. 1930s",
                          title : "",
                          source : "",
                          render : ()=> <img alt="The Mall" src={general_Gallery1} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "The Mall c. 1930s",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="The Mall" src={general_Gallery2} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "The Mall c. 1930s",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="The Mall" src={general_Gallery3} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "The Mall, Hall road junction c. 1941",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="The Mall, Hall road junction" src={general_Gallery4} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "The Mall c. 1950s",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="The Mall" src={general_Gallery5} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "The Mall",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="The Mall" src={general_Gallery6} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "The Mall c. 1959",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="The Mall" src={general_Gallery7} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Aerial view of the Mall road c. 1920",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Aerial view of the Mall road" src={general_Gallery8} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '50%', marginLeft: '25%'}}></img>,
                        },
                        {
                          description : "Picture taken from Cathedral Bell Tower c. 1900s",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Aerial view of the Mall road" src={general_Gallery13} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Picture taken from Cathedral Bell Tower c. 1985 (Bryan Porter)",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Aerial view of the Mall road" src={general_Gallery14} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Map of The Mall c. 1867",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Map of The Mall" src={general_Gallery9} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Map of The Mall c. 1867",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Map of The Mall" src={general_Gallery11} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "Map of The Mall c. 1927",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Map of The Mall" src={general_Gallery10} style={window.innerHeight > 675 ? {width: '90%', marginLeft: '5%'} : {width: '80%', marginLeft: '10%'}}></img>,
                        },
                        {
                          description : "The Mall c. 1940s",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="The Mall" src={general_Gallery12} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        }
                      ]
                    }
                  />
                  <Overlay
                    oId="4"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : "An artist's impression of The Mall",
                          title : "",
                          source : "",
                          render : ()=> <img alt="An artist's impression of The Mall" src={painting_Gallery1} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        },
                        {
                          description : "An artist's impression of The Mall",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="An artist's impression of The Mall" src={painting_Gallery2} style={window.innerHeight > 675 ? {width: '45%', marginLeft: '27.5%'} : {width: '40%', marginLeft: '30%'}}></img>,
                        },
                        {
                          description : "An artist's impression of Anarkali Market",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="An artist's impression of Anarkali Market" src={Anarkali_Gall_3} style={window.innerHeight > 675 ? {width: '45%', marginLeft: '27.5%'} : {width: '40%', marginLeft: '30%'}}></img>,
                        },
                        {
                          description : "An artist's impression of the General Post Office (GPO)",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="An artist's impression of the General Post Office (GPO)" src={GPO_Gall_9} style={window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}></img>,
                        }
                      ]
                    }
                  />
                  <Overlay
                    oId="5"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : "Lahore Museum Centenary Stamp",
                          title : "",
                          source : "",
                          render : ()=> <img alt="Lahore Museum Centenary Stamp" src={stamp_Gallery1} style={window.innerHeight > 675 ? {width: '40%', marginLeft: '30%'} : {width: '35%', marginLeft: '32.5%'}}></img>,
                        },
                        {
                          description : "Aitchison College Centenary Stamp",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Aitchison College Centenary Stamp" src={Aitchison_Gall_5} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '50%', marginLeft: '25%'}}></img>,
                        },
                        {
                          description : "NCA Centenary Stamp",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="NCA Centenary Stamp" src={stamp_Gallery2} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '50%', marginLeft: '25%'}}></img>,
                        },
                        {
                          description : "GPO Stamp",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="GPO Stamp" src={GPO_Gall_12} style={window.innerHeight > 675 ? {width: '45%', marginLeft: '27.5%'} : {width: '40%', marginLeft: '30%'}}></img>,
                        },
                        {
                          description : "Stamp celebrating 150 years of Lahore High Court",
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Lahore High Court Stamp" src={HighCourt_Gall_17} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        }
                      ]
                    }
                  />
                  <Overlay
                    oId="6"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [
                        {
                          description : "A poem by Qamar Jalalabadi",
                          title : "",
                          source : "",
                          render : ()=> <img alt="Poem" src={poem_Gallery1} style={window.innerHeight > 675 ? {width: '50%', marginLeft: '25%'} : {width: '40%', marginLeft: '30%'}}></img>,
                        }
                      ]
                    }
                  />
                  <Overlay
                    oId="7"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    withAudio
                    slides={
                      [
                        {
                          description : <span>Account of Winston Churchill riding a horse on Mall road from Lahore Cantt to Tollinton Market. From <i>Yadon Ki Basti</i> by Khalid Masood Qureshi</span>,
                          title : "",
                          source : "",
                          audioLink: churchill_audio,
                          render : ()=> <img alt="Portrait of Winston Churchill" src={narration_Gallery1} style={window.innerHeight > 675 ? {width: '40%', marginLeft: '30%'} : {width: '35%', marginLeft: '32.5%'}}></img>,
                        },
                        {
                          description : <span>An excerpt on The Ganga Ram Hospital From Som Anand’s <i>Portrait of a Lost City</i></span>,
                          title : "Sample Title",
                          source : "",
                          audioLink: ganga_ram_hospital_audio,
                          render : ()=> <img alt="Portrait of Sir Ganga Ram" src={narration_Gallery2} style={window.innerHeight > 675 ? {width: '35%', marginLeft: '32.5%'} : {width: '30%', marginLeft: '35%'}}></img>,
                        },
                        {
                          description : <span>A description of the Lahore Museum taken from <i>Lahore: A Memoir</i> by Muhammad Saeed</span>,
                          title : "Sample Title",
                          source : "",
                          audioLink: museam_audio,
                          render : ()=> <img alt="Lahore Museum" src={places_Gallery8} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : <span>A description of the British ‘Club’ Culture taken from <i>Lahore: A Memoir</i> by Muhammad Saeed</span>,
                          title : "Sample Title",
                          source : "",
                          audioLink: mont_audio,
                          render : ()=> <img alt="Montgomery Hall" src={places_Gallery6} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : <span>An excerpt on the Lawrence Garden taken from <i>Lahore: A Memoir</i> by Muhammad Saeed</span>,
                          title : "Lawrence Garden",
                          source : "",
                          audioLink: lawrance_garden,
                          render : ()=> <img alt="Lawrence Garden" src={places_Gallery4} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '50%', marginLeft: '25%'}}></img>,
                        },
                        {
                          description : <span>An account of the Montgomery Hall taken from <i>Lahore: A Memoir</i> by Muhammad Saeed</span>,
                          title : "Sample Title",
                          source : "",
                          audioLink: mont1_audio,
                          render : ()=> <img alt="Montgomery Hall" src={places_Gallery5} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '50%', marginLeft: '25%'}}></img>,
                        },
                        {
                          description : <span>A description of the statue of Sir John Lawrence taken from <i>Lahore: A Memoir</i> by Muhammad Saeed</span>,
                          title : "Sample Title",
                          source : "",
                          audioLink: lawrance_stat_audio,
                          render : ()=> <img alt="Lawrence Statue" src={HighCourt_Gall_19} style={window.innerHeight > 675 ? {width: '38%', marginLeft: '31%'} : {width: '34%', marginLeft: '33%'}}></img>,
                        }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "gallery",
        next : "gallery",
        menuInverted : true,
        crossFadeTrans: true,
        hideChapterNumber: false,
        hideVerticalNav: false,
        hideBottomBar: true,
        bottomBarMessage: 'Select a video',
        hideBottomBarScroll: true,
        showThemeButton: true,
      },
    }
  }
}

function topoSortSlides(slides){
  const visitedSet = {};
  const orderArr = [];
  const allSlidesMap = {};

  for(let i in slides){
    for(let j in slides[i].slides){
      allSlidesMap[j] = slides[i].slides[j];
    }
  }

  Object.keys(allSlidesMap).forEach((s)=>{
    topoSortNode(s, allSlidesMap, orderArr, visitedSet)
  })
  return orderArr.reverse().reduce((acc,d,i)=>{
    acc[d] = i;
    return acc;
  },{});
}

function topoSortNode(nodename,nodes, orderArr, visitedSet){
  if(nodename === null || visitedSet[nodename]){
    return orderArr;
  }

  visitedSet[nodename] = true;
  topoSortNode(nodes[nodename].next, nodes, orderArr, visitedSet);
  orderArr.push(nodename);

  return orderArr;
}

const slideOrder = topoSortSlides(slideMap)

const chapterArr = ["chapter1","chapter2","chapter3","chapter4","chapter5"];


const mobileSlideMap = {
  "home" : {
    name: "Project Home",
    showinNav: true,
    component : (
      <MobileSlide>
        {
          (props)=>{
            return (
              <ProjectTitleMobile
                image={ProjectTitleBack}
                title="The Mall"
                subTitle = "History and Culture, Now and Then"
                description={<span>An audio-visual experience exploring the history of the most prominent thoroughfare in Lahore</span>}
                to="themes"
              />
            )
          }
        }
      </MobileSlide>
    ),
    menuInverted: false,
  },
  "themes" : {
    name: "Themes",
    showinNav: true,
    component : (
      <MobileSlide>
        {(props) => {
          return (
            <div>
              <Themes
                themes={[{theme: 'Illustrated Map', linkTo: 'map'}, {theme: 'Literary Journeys', linkTo: 'journeys'}, {theme: 'Gallery', linkTo: 'gallery'}]}
                images={[{image: mapBg, id: 'map'}, { image: literatureBg, id: 'journeys'}, { image: galleryBg, id: 'gallery'}]}
                image={ProjectThemesBack}
              />
            </div>
          )}}
      </MobileSlide>
    ),
    menuInverted : true,
  },
  "map": {
    name: "Illustrated Map",
    showinNav: true,
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div style={{background: '#E6C96F', minHeight: '100vh'}}>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title)}>Illustrated Map</p>
                  <p className={classNames(mobileStyles.slide_page_Desc)}>Illustration by Nayyab Naveed</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_audio)}>Click on a landmark to continue</p>
                </div>
                <Map/>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/themes" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button}`}>Back to Themes</p>
                    </Link>
                  </div>
                </div>
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: false
  },
  "journeys": {
    name: "Literary Journeys",
    showinNav: true,
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent} style={{minHeight: window.innerHeight, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                <img src={literatureSlideBg} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Literary Journeys</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted)}>Short videos based on excerpts from famous literary pieces mentioning landmarks of the Mall</p>
                </div>
                <div className={mobileStyles.mobile_layout_journeys_container}>
                  <div id={mobileStyles.remove_padded_bottom} className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_journeys, mobileStyles.padded_top, mobileStyles.padded_bottom)}>
                    <VideoLink inverted setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["1",0]} image={LambiSarak} linkMessage="Krishan Chandar"/>
                    <VideoLink inverted setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["1",1]} image={Kim} linkMessage="Rudyard Kipling"/>
                  </div>
                  <div id={mobileStyles.remove_padded_top} className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_journeys, mobileStyles.padded_top, mobileStyles.padded_bottom)}>
                    <VideoLink inverted setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["1",2]} image={Overcoat} linkMessage="Ghulam Abbas"/>
                    <VideoLink inverted setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["1",3]} image={Bano} linkMessage="Bano Qudsia"/>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/themes" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Themes</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <p>Dou Forlong Lambi Sarak - Krishan Chandar</p>,
                      title : "",
                      source : "",
                      render : ()=> <VideoFrame link='https://www.youtube.com/embed/lQEhkCbN9mg'/>,
                    },
                    {
                      description : <p>Kim - Rudyard Kipling</p>,
                      title : "",
                      source : "",
                      render : ()=> <VideoFrame link='https://www.youtube.com/embed/v1b65ZM1wfU'/>,
                    },
                    {
                      description : <p>Overcoat - Ghulam Abbas</p>,
                      title : "",
                      source : "",
                      render : ()=>  <VideoFrame link='https://www.youtube.com/embed/wkLVuGjcRSU'/>,
                    },
                    {
                      description : <p>Raja Gidh - Bano Qudsia</p>,
                      title : "",
                      source : "",
                      render : () =>  <VideoFrame link='https://www.youtube.com/embed/nNPTK2K4W7Y'/>,
                    }]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "zamzamah": {
    name: "Zamzamah",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Zamzamah Cannon</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}><span>Narration source: Rudyard Kipling - <i>Kim</i></span></p>
                  <div className={mobileStyles.mobile_audio_container}>
                    <AudioLink link={Zamzama_audio}/>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <CrossFadeImages images={{then: Zamzama_Old, now: Zamzama_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                  <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                    <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Then</p>
                    </div>
                    <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Now</p>
                    </div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <p style={{marginTop: '10px'}} className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Gallery</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",2])} alt="Zamzamah" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Zamzama_Gall_1}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",3])} alt="Zamzamah" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Zamzama_Gall_2}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",4])} alt="Zamzamah" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Zamzama_Gall_3}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",5])} alt="Zamzamah" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Zamzama_Gall_4}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",6])} alt="Zamzamah" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Zamzama_Gall_5}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",7])} alt="Zamzamah" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Zamzama_Gall_6}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",8])} alt="Zamzamah" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Zamzama_Gall_7}/>
                      </div>
                  </HorizontalScroll>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <div className={mobileStyles.places_chevrons_container}>
                    <div onClick={props.moveBackward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Zamzamah Cannon c. 1920</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Zamzamah" src={Zamzama_Old} id={overlay_styles.Zamzama_Old}></img>,
                      },
                      {
                        description : <span>Zamzamah Cannon</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Zamzamah" src={Zamzama_Now} id={overlay_styles.Zamzama_Now}></img>,
                      },
                      {
                        description : <span>Zamzamah Cannon (Ricalton, Jones, 1903)</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Zamzamah" src={Zamzama_Gall_1} id={overlay_styles.Zamzama_Gall_1}></img>,
                      },
                      {
                        description : <span>Zamzamah Cannon in front of University Hall c. 1910</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Zamzamah" src={Zamzama_Gall_2} id={overlay_styles.Zamzama_Gall_2}></img>,
                      },
                      {
                        description : <span>Zamzamah Cannon c. 1940s</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Zamzamah" src={Zamzama_Gall_3} id={overlay_styles.Zamzama_Gall_3}></img>,
                      },
                      {
                        description : <span>Zamzamah Cannon (closeup of plaque) c. 1946</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Zamzamah" src={Zamzama_Gall_4} id={overlay_styles.Zamzama_Gall_4}></img>,
                      },
                      {
                        description : <span>Zamzamah Cannon c. 1960</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Zamzamah" src={Zamzama_Gall_5} id={overlay_styles.Zamzama_Gall_5}></img>,
                      },
                      {
                        description : <span>Zamzamah Cannon c. 1970s</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Zamzamah" src={Zamzama_Gall_6} id={overlay_styles.Zamzama_Gall_6}></img>,
                      },
                      {
                        description : <span>Zamzamah Cannon stamp</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Zamzamah" src={Zamzama_Gall_7} id={overlay_styles.Zamzama_Gall_7}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "aitchison": {
    name: "Aitchison",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Aitchison College</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}><span>Narration source: Muhammad Saeed - <i>Lahore: A Memoir</i></span></p>
                  <div className={mobileStyles.mobile_audio_container}>
                    <AudioLink link={aitchison_audio}/>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <CrossFadeImages images={{then: Aitchison_Old, now: Aitchison_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                  <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                    <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Then</p>
                    </div>
                    <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Now</p>
                    </div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <p style={{marginTop: '10px'}} className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Gallery</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",2])} alt="Aitchison College" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Aitchison_Gall_3}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",3])} alt="Aitchison College" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Aitchison_Gall_4}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",4])} alt="Aitchison College" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Aitchison_Gall_2}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",5])} alt="Aitchison College" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Aitchison_Gall_5}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",6])} alt="Aitchison College" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Aitchison_Gall_1}/>
                      </div>
                  </HorizontalScroll>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <div className={mobileStyles.places_chevrons_container}>
                    <div onClick={props.moveBackward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Aitchison College c. 1910s</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Aitchison College" src={Aitchison_Old} id={overlay_styles.Aitchison_Old}></img>,
                      },
                      {
                        description : <span>Aitchison College</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Aitchison College" src={Aitchison_Now} id={overlay_styles.Aitchison_Now}></img>,
                      },
                      {
                        description : <span>Aitchison College c. 1900s</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Aitchison College" src={Aitchison_Gall_3} id={overlay_styles.Aitchison_Gall_3}></img>,
                      },
                      {
                        description : <span>Aitchison College c. 1920</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Aitchison College" src={Aitchison_Gall_4} id={overlay_styles.Aitchison_Gall_4}></img>,
                      },
                      {
                        description : <span>Aitchison College Old Building (the album of Private J W Linley 1923-1938)</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Aitchison College" src={Aitchison_Gall_2} id={overlay_styles.Aitchison_Gall_2}></img>,
                      },
                      {
                        description : <span>Stamp celebrating the centenary of Aitchison College</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Aitchison College" src={Aitchison_Gall_5} id={overlay_styles.Aitchison_Gall_5}></img>,
                      },
                      {
                        description : <span>A painting of Aitchison College</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Aitchison College" src={Aitchison_Gall_1} id={overlay_styles.Aitchison_Gall_1}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "punjablibrary": {
    name: "Punjab Public Library",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Punjab Public Library</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}><span>Narration source: Muhammad Saeed - <i>Lahore: A Memoir</i></span></p>
                  <div className={mobileStyles.mobile_audio_container}>
                    <AudioLink link={PPL_audio}/>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <CrossFadeImages images={{then: PPL_Old, now: PPL_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                  <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                    <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Then</p>
                    </div>
                    <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Now</p>
                    </div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <p style={{marginTop: '10px'}} className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Gallery</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img onClick={()=> props.setDisplayedOverlay(["1",2])} alt="Punjab Public Library" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={PPL_Gall_3}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img onClick={()=> props.setDisplayedOverlay(["1",3])} alt="Punjab Public Library" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={PPL_Gall_1}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img onClick={()=> props.setDisplayedOverlay(["1",4])} alt="Punjab Public Library" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={PPL_Gall_2}/>
                      </div>
                  </HorizontalScroll>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <div className={mobileStyles.places_chevrons_container}>
                    <div onClick={props.moveBackward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Punjab Public Library</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Punjab Public Library" src={PPL_Old} id={overlay_styles.PPL_Old}></img>,
                      },
                      {
                        description : <span>Punjab Public Library</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Punjab Public Library" src={PPL_Now} id={overlay_styles.PPL_Now}></img>,
                      },
                      {
                        description : <span>Punjab Public library c. 1870</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Punjab Public Library" src={PPL_Gall_3} id={overlay_styles.PPL_Gall_3}></img>,
                      },
                      {
                        description : <span>Punjab Public Library 1920</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Punjab Public Library" src={PPL_Gall_1} id={overlay_styles.PPL_Gall_1}></img>,
                      },
                      {
                        description : <span>Punjab Public Library c. 1938</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Punjab Public Library" src={PPL_Gall_2} id={overlay_styles.PPL_Gall_2}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "freemasons": {
    name: "Freemason's Lodge",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div style={{minHeight: window.innerHeight}} className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Freemason's Lodge</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}><span>Narration source: Muhammad Saeed - <i>Lahore: A Memoir</i></span></p>
                  <div className={mobileStyles.mobile_audio_container}>
                    <AudioLink link={masonic_audio}/>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <p style={{marginTop: '10px'}} className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Gallery</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top, mobileStyles.padded_bottom)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",0])} src={Freemasons_One} alt="Freemasons Lodge Plaque" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",1])} src={Freemasons_Two} alt="Freemasons Lodge" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",2])} src={Freemasons_Three} alt="Freemasons Lodge Painting" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)}/>
                    </div>
                  </HorizontalScroll>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <div className={mobileStyles.places_chevrons_container}>
                    <div onClick={props.moveBackward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Freemasons Hall Plaque</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Freemasons Hall" src={Freemasons_One} id={overlay_styles.Freemasons_One}></img>,
                      },
                      {
                        description : <span>Freemasons Hall</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Freemasons Hall" src={Freemasons_Two} id={overlay_styles.Freemasons_Two}></img>,
                      },
                      {
                        description : <span>A painting of the Freemasons Hall</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Freemasons Hall" src={Freemasons_Three} id={overlay_styles.Freemasons_Three}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "tollington": {
    name: "Tollington Market",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Tollington Market</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <CrossFadeImages images={{then: Tollinton_Old, now: Tollinton_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                  <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                    <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Then</p>
                    </div>
                    <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Now</p>
                    </div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <p style={{marginTop: '10px'}} className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Gallery</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",2])} alt="Tollington Market" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Tollinton_Gall_8}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",3])} alt="Tollington Market" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Tollinton_Gall_4}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",4])} alt="Tollington Market" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Tollinton_Gall_1}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",5])} alt="Tollington Market" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Tollinton_Gall_3}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",6])} alt="Tollington Market" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Tollinton_Gall_5}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",7])} alt="Tollington Market" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Tollinton_Gall_6}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",8])} alt="Tollington Market" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Tollinton_Gall_9}/>
                    </div>
                  </HorizontalScroll>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <div className={mobileStyles.places_chevrons_container}>
                    <div onClick={props.moveBackward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Tollington Market c. 1907</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Tollington Market" src={Tollinton_Old} id={overlay_styles.Tollinton_Old}></img>,
                      },
                      {
                        description : <span>Tollington Market</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Tollington Market" src={Tollinton_Now} id={overlay_styles.Tollinton_Now}></img>,
                      },
                      {
                        description : <span>Tollington Market under construction c. 1863</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Tollington Market" src={Tollinton_Gall_8} id={overlay_styles.Tollinton_Gall_8}></img>,
                      },
                      {
                        description : <span>Tollington Market or Opening of the Punjab Exhibition of Arts and Industry at Lahore, from Illustrated London News, 1864</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Tollington Market" src={Tollinton_Gall_4} id={overlay_styles.Tollinton_Gall_4}></img>,
                      },
                      {
                        description : <span>Poster of Punjab Industrial Exhibition aka Tollington Market c. 1893</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Tollington Market" src={Tollinton_Gall_1} id={overlay_styles.Tollinton_Gall_1}></img>,
                      },
                      {
                        description : <span>Tollington Market, or Inside View of the Exhibition Building</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Tollington Market" src={Tollinton_Gall_3} id={overlay_styles.Tollinton_Gall_3}></img>,
                      },
                      {
                        description : <span>Tollington Market, The Mall</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Tollington Market" src={Tollinton_Gall_5} id={overlay_styles.Tollinton_Gall_5}></img>,
                      },
                      {
                        description : <span>Tollington Market and Railway Building Labor Returns</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Tollington Market" src={Tollinton_Gall_6} id={overlay_styles.Tollinton_Gall_6}></img>,
                      },
                      {
                        description : <span>A painting of the Tollington Market</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Tollington Market" src={Tollinton_Gall_9} id={overlay_styles.Tollinton_Gall_9}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "anarkali": {
    name: "Anarkali Market",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Anarkali</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}><span>Narration source: Saadat Hasan Manto - <i>Naya Qanoon</i></span></p>
                  <div className={mobileStyles.mobile_audio_container}>
                    <AudioLink link={anarkali_audio}/>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <CrossFadeImages images={{then: Anarkali_Old, now: Anarkali_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                  <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                    <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Then</p>
                    </div>
                    <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Now</p>
                    </div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <p style={{marginTop: '10px'}} className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Gallery</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",2])} alt="Anarkali" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Anarkali_Gall_6}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",3])} alt="Anarkali" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Anarkali_Gall_5}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",4])} alt="Anarkali" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Anarkali_Gall_1}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",5])} alt="Anarkali" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Anarkali_Gall_2}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",6])} alt="Anarkali" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={Anarkali_Gall_3}/>
                    </div>
                  </HorizontalScroll>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <div className={mobileStyles.places_chevrons_container}>
                    <div onClick={props.moveBackward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Anarkali Street</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Anarkali" src={Anarkali_Old} id={overlay_styles.Anarkali_Old}></img>,
                      },
                      {
                        description : <span>Anarkali Street</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Anarkali" src={Anarkali_Now} id={overlay_styles.Anarkali_Now}></img>,
                      },
                      {
                        description : <span>An old advertisement of a <i>saree</i> vendor in Anarkali</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Anarkali" src={Anarkali_Gall_6} id={overlay_styles.Anarkali_Gall_6}></img>,
                      },
                      {
                        description : <span>Anarkali Market c. 1980</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Anarkali" src={Anarkali_Gall_5} id={overlay_styles.Anarkali_Gall_5}></img>,
                      },
                      {
                        description : <span>A painting of Anarkali Market</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Anarkali" src={Anarkali_Gall_1} id={overlay_styles.Anarkali_Gall_1}></img>,
                      },
                      {
                        description : <span>An artist's impression of Anarkali Market</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Anarkali" src={Anarkali_Gall_2} id={overlay_styles.Anarkali_Gall_2}></img>,
                      },
                      {
                        description : <span>A painting of Anarkali Market</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Anarkali" src={Anarkali_Gall_3} id={overlay_styles.Anarkali_Gall_3}></img>,
                      },
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "gpo": {
    name: "General Post Office",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>General Post Office (GPO)</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}><span>Narration source: Colonel H.R Goulding - <i>Reminiscences of a Resident</i></span></p>
                  <div className={mobileStyles.mobile_audio_container}>
                    <AudioLink link={GPO_audio}/>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <CrossFadeImages images={{then: GPO_Old, now: GPO_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                  <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                    <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Then</p>
                    </div>
                    <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Now</p>
                    </div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <p style={{marginTop: '10px'}} className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Gallery</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",2])} alt="GPO" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={GPO_Gall_1}/>
                    </div><div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",3])} alt="GPO" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={GPO_Gall_3}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",4])} alt="GPO" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={GPO_Gall_4}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",5])} alt="GPO" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={GPO_Gall_12}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",6])} alt="GPO" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={GPO_Gall_9}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",7])} alt="GPO" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={GPO_Gall_11}/>
                    </div>
                  </HorizontalScroll>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <div className={mobileStyles.places_chevrons_container}>
                    <div onClick={props.moveBackward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Lahore General Post Office c. 1910s</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="GPO" src={GPO_Old} id={overlay_styles.GPO_Old}></img>,
                      },
                      {
                        description : <span>Lahore General Post Office</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="GPO" src={GPO_Now} id={overlay_styles.GPO_Now}></img>,
                      },
                      {
                        description : <span>General Post Office c. 1910s</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="GPO" src={GPO_Gall_1} id={overlay_styles.GPO_Gall_1}></img>,
                      },
                      {
                        description : <span>General Post Office c. 1910s</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="GPO" src={GPO_Gall_3} id={overlay_styles.GPO_Gall_3}></img>,
                      },
                      {
                        description : <span>General Post Office postcard c. 1964</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="GPO" src={GPO_Gall_4} id={overlay_styles.GPO_Gall_4}></img>,
                      },
                      {
                        description : <span>General Post Office on a postage stamp</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="GPO" src={GPO_Gall_12} id={overlay_styles.GPO_Gall_12}></img>,
                      },
                      {
                        description : <span>A painting of the General Post Office</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="GPO" src={GPO_Gall_9} id={overlay_styles.GPO_Gall_9}></img>,
                      },
                      {
                        description : <span>An artist's impression of the General Post Office</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="GPO" src={GPO_Gall_11} id={overlay_styles.GPO_Gall_11}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "highcourt": {
    name: "Lahore High Court",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Lahore High Court</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}><span>Narration source: Muhammad Saeed - <i>Lahore: A Memoir</i></span></p>
                  <div className={mobileStyles.mobile_audio_container}>
                    <AudioLink link={high_court_audio}/>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <CrossFadeImages images={{then: HighCourt_Old, now: HighCourt_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                  <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                    <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Then</p>
                    </div>
                    <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Now</p>
                    </div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <p style={{marginTop: '10px'}} className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Gallery</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_33)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",2])} alt="Lahore High Court" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={HighCourt_Gall_1}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",3])} alt="Lahore High Court" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={HighCourt_Gall_19}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",4])} alt="Lahore High Court" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={HighCourt_Gall_7}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",5])} alt="Lahore High Court" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={HighCourt_Gall_4}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",6])} alt="Lahore High Court" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={HighCourt_Gall_12}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",7])} alt="Lahore High Court" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={HighCourt_Gall_10}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",8])} alt="Lahore High Court" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={HighCourt_Gall_8}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",9])} alt="Lahore High Court" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={HighCourt_Gall_5}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",10])} alt="Lahore High Court" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={HighCourt_Gall_17}/>
                    </div>
                  </HorizontalScroll>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <div className={mobileStyles.places_chevrons_container}>
                    <div onClick={props.moveBackward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Lahore High court c. 1940s</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore High Court" src={HighCourt_Old} id={overlay_styles.HighCourt_Old}></img>,
                      },
                      {
                        description : <span>Lahore High Court</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore High Court" src={HighCourt_Now} id={overlay_styles.HighCourt_Now}></img>,
                      },
                      {
                        description : <span>John Lawrence statue (in front of High Court) c. 1910s</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_1} id={overlay_styles.HighCourt_Gall_1}></img>,
                      },
                      {
                        description : <span>Lawrence's Statue in front of the High Court</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_19} id={overlay_styles.HighCourt_Gall_19}></img>,
                      },
                      {
                        description : <span>Lahore High court, an album photo, c. 1880s</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_7} id={overlay_styles.HighCourt_Gall_7}></img>,
                      },
                      {
                        description : <span>Lahore High Court c. 1908</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_4} id={overlay_styles.HighCourt_Gall_4}></img>,
                      },
                      {
                        description : <span>Lahore High Court c. 1925</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_12} id={overlay_styles.HighCourt_Gall_12}></img>,
                      },
                      {
                        description : <span>Lahore High Court Bar Association Library c. 1933</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_10} id={overlay_styles.HighCourt_Gall_10}></img>,
                      },
                      {
                        description : <span>Lahore High Court</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_8} id={overlay_styles.HighCourt_Gall_8}></img>,
                      },
                      {
                        description : <span>Lahore High court c. 1960s</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_5} id={overlay_styles.HighCourt_Gall_5}></img>,
                      },
                      {
                        description : <span>Stamps celebrating 150 years of the Lahore High Court</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore High Court" src={HighCourt_Gall_17} id={overlay_styles.HighCourt_Gall_17}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "ymca": {
    name: "Lahore High Court",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div style={{minHeight: window.innerHeight}} className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>YMCA</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}><span>Narration source: Muhammad Saeed - <i>Lahore: A Memoir</i></span></p>
                  <div className={mobileStyles.mobile_audio_container}>
                    <AudioLink link={YMCA_audio}/>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <CrossFadeImages images={{then: YMCA_Old, now: YMCA_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                  <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                    <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Then</p>
                    </div>
                    <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Now</p>
                    </div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>YMCA c. 1920</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="YMCA" src={YMCA_Old} id={overlay_styles.YMCA_Old}></img>,
                      },
                      {
                        description : <span>YMCA</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="YMCA" src={YMCA_Now} id={overlay_styles.YMCA_Now}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "gangaram": {
    name: "Gangaram Trust Building",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div style={{minHeight: window.innerHeight}} className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>YMCA</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}><span>Narration source: Muhammad Saeed - <i>Lahore: A Memoir</i></span></p>
                  <div className={mobileStyles.mobile_audio_container}>
                    <AudioLink link={ganga_ram_audio}/>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <img onClick={()=> props.setDisplayedOverlay(["1",0])} className={classNames(mobileStyles.shadowImage, mobileStyles.only_image_location)} src={GangaRamTrust_Now}/>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Ganga Ram Building</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Ganga Ram Building" src={GangaRamTrust_Now} id={overlay_styles.GangaRamTrust_Now}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "alhamra": {
    name: "Alhamra Arts Council",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div style={{minHeight: window.innerHeight}} className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Alhamra Arts Council</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <img onClick={()=> props.setDisplayedOverlay(["1",0])} className={classNames(mobileStyles.shadowImage, mobileStyles.only_image_location)} src={AlhamraArt}/>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Alhamra Arts Center</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Alhamra Arts Center" src={AlhamraArt} id={overlay_styles.AlhamraArt}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "charingcross": {
    name: "Charing Cross",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Charing Cross</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <CrossFadeImages images={{then: CharingCross_Old, now: CharingCross_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                  <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                    <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Then</p>
                    </div>
                    <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Now</p>
                    </div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <p style={{marginTop: '10px'}} className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Gallery</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",2])} alt="Charing Cross" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={CharingCross_Gall_6}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",3])} alt="Charing Cross" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={CharingCross_Gall_3}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",4])} alt="Charing Cross" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={CharingCross_Gall_1}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",5])} alt="Charing Cross" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={CharingCross_Gall_7}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",6])} alt="Charing Cross" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={CharingCross_Gall_4}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",7])} alt="Charing Cross" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={CharingCross_Gall_2}/>
                    </div>
                  </HorizontalScroll>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <div className={mobileStyles.places_chevrons_container}>
                    <div onClick={props.moveBackward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Charing Cross Pavillion c. 1910s with Queen Victoria's statue</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Charing Cross" src={CharingCross_Old} id={overlay_styles.CharingCross_Old}></img>,
                      },
                      {
                        description : <span>Charing Cross. Queen Victoria's statue has been replaced by a replica of the Quran</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Charing Cross" src={CharingCross_Now} id={overlay_styles.CharingCross_Now}></img>,
                      },
                      {
                        description : <span>Charing Cross Pavillion installation ceremony of Victoria's statue</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Charing Cross" src={CharingCross_Gall_6} id={overlay_styles.CharingCross_Gall_6}></img>,
                      },
                      {
                        description : <span>Charing Cross Pavillion (the album of Private J W Linley 1923-1938)</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Charing Cross" src={CharingCross_Gall_3} id={overlay_styles.CharingCross_Gall_3}></img>,
                      },
                      {
                        description : <span>Charing Cross c. 1930s</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Charing Cross" src={CharingCross_Gall_1} id={overlay_styles.CharingCross_Gall_1}></img>,
                      },
                      {
                        description : <span>Queen Victoria's statue being transported from Charing Cross to Lahore Museum</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Charing Cross" src={CharingCross_Gall_7} id={overlay_styles.CharingCross_Gall_7}></img>,
                      },
                      {
                        description : <span>Charing cross Pavillion c. 1960s. Queen Victoria' Statue has been removed</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Charing Cross" src={CharingCross_Gall_4} id={overlay_styles.CharingCross_Gall_4}></img>,
                      },
                      {
                        description : <span>Charing Cross c. 1973</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Charing Cross" src={CharingCross_Gall_2} id={overlay_styles.CharingCross_Gall_2}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "dyalsingh": {
    name: "Dyal Singh Mansion",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Dyal Singh Mansion</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}><span>Narration source: Muhammad Saeed - <i>Lahore: A Memoir</i></span></p>
                  <div className={mobileStyles.mobile_audio_container}>
                    <AudioLink link={dyal_singh_audio}/>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <CrossFadeImages images={{then: DyalSinghMansion_Old, now: DyalSinghMansion_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                  <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                    <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Then</p>
                    </div>
                    <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Now</p>
                    </div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <p style={{marginTop: '10px'}} className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Gallery</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",2])} alt="Dyal Singh Mansion" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={DyalSinghMansion_Gall_2}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",3])}  alt="Dyal Singh Mansion" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={DyalSinghMansion_Gall_1}/>
                    </div>
                  </HorizontalScroll>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <div className={mobileStyles.places_chevrons_container}>
                    <div onClick={props.moveBackward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Dyal Singh Mansion</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Dyal Singh Mansion" src={DyalSinghMansion_Old} id={overlay_styles.DyalSinghMansion_Old}></img>,
                      },
                      {
                        description : <span>Dyal Singh Mansion</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Dyal Singh Mansion" src={DyalSinghMansion_Now} id={overlay_styles.DyalSinghMansion_Now}></img>,
                      },
                      {
                        description : <span>Dyal Singh Building c. 1930s</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Dyal Singh Mansion" src={DyalSinghMansion_Gall_2} id={overlay_styles.DyalSinghMansion_Gall_2}></img>,
                      },
                      {
                        description : <span>Dyal Singh Building c. 1959</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Dyal Singh Mansion" src={DyalSinghMansion_Gall_1} id={overlay_styles.DyalSinghMansion_Gall_1}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "punjabassembly": {
    name: "Punjab Assembly",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Punjab Assembly</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <CrossFadeImages images={{then: PunjabAssembly_Old, now: PunjabAssembly_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                  <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                    <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Then</p>
                    </div>
                    <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Now</p>
                    </div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <p style={{marginTop: '10px'}} className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Gallery</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",2])} alt="Punjab Assembly" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={PunjabAssembly_Gall_1}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",3])} alt="Punjab Assembly" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={PunjabAssembly_Gall_2}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",4])} alt="Punjab Assembly" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={PunjabAssembly_Gall_3}/>
                    </div>
                  </HorizontalScroll>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <div className={mobileStyles.places_chevrons_container}>
                    <div onClick={props.moveBackward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Punjab Assembly Hall c. 1940s</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Punjab Assembly" src={PunjabAssembly_Old} id={overlay_styles.PunjabAssembly_Old}></img>,
                      },
                      {
                        description : <span>Punjab Assembly</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Punjab Assembly" src={PunjabAssembly_Now} id={overlay_styles.PunjabAssembly_Now}></img>,
                      },
                      {
                        description : <span>Punjab Assembly Hall c. 1940s</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Punjab Assembly" src={PunjabAssembly_Gall_1} id={overlay_styles.PunjabAssembly_Gall_1}></img>,
                      },
                      {
                        description : <span>Punjab Assembly Hall c. 1940s</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Punjab Assembly" src={PunjabAssembly_Gall_2} id={overlay_styles.PunjabAssembly_Gall_2}></img>,
                      },
                      {
                        description : <span>A painter's impression of the Punjab Assembly Hall</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Punjab Assembly" src={PunjabAssembly_Gall_3} id={overlay_styles.PunjabAssembly_Gall_3}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "governorhouse": {
    name: "Governor House",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Governor House</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}><span>Narration source: Pran Nevile - <i>Lahore: A Sentimental Journey</i></span></p>
                  <div className={mobileStyles.mobile_audio_container}>
                    <AudioLink link={government_audio}/>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <CrossFadeImages images={{then: GovernorHouse_Old, now: GovernorHouse_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                  <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                    <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Then</p>
                    </div>
                    <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Now</p>
                    </div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <p style={{marginTop: '10px'}} className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Gallery</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",2])} alt="Governor House" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={GovernorHouse_Gall_1}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",3])} alt="Governor House" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={GovernorHouse_Gall_2}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",4])} alt="Governor House" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={GovernorHouse_Gall_3}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",5])} alt="Governor House" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={GovernorHouse_Gall_4}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",6])} alt="Governor House" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={GovernorHouse_Gall_6}/>
                    </div>
                  </HorizontalScroll>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <div className={mobileStyles.places_chevrons_container}>
                    <div onClick={props.moveBackward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Government House c. 1875</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Governor House" src={GovernorHouse_Old} id={overlay_styles.GovernorHouse_Old}></img>,
                      },{
                        description : <span>Governor House</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Governor House" src={GovernorHouse_Now} id={overlay_styles.GovernorHouse_Now}></img>,
                      },
                      {
                        description : <span>Government house</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Governor House" src={GovernorHouse_Gall_1} id={overlay_styles.GovernorHouse_Gall_1}></img>,
                      },
                      {
                        description : <span>Government House, Lahore c. 1869</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Governor House" src={GovernorHouse_Gall_2} id={overlay_styles.GovernorHouse_Gall_2}></img>,
                      },
                      {
                        description : <span>Government House, Lahore c. 1910 (Postcard)</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Governor House" src={GovernorHouse_Gall_3} id={overlay_styles.GovernorHouse_Gall_3}></img>,
                      },
                      {
                        description : <span>Government House c.1910</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Governor House" src={GovernorHouse_Gall_4} id={overlay_styles.GovernorHouse_Gall_4}></img>,
                      },
                      {
                        description : <span>An advertisement shows Ayub Khan watering a plant at the Government House</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Governor House" src={GovernorHouse_Gall_6} id={overlay_styles.GovernorHouse_Gall_6}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "nca": {
    name: "National College of Arts (NCA)",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>National College of Arts (NCA)</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}><span>Narration source: Pran Nevile - <i>Lahore: A Sentimental Journey</i></span></p>
                  <div className={mobileStyles.mobile_audio_container}>
                    <AudioLink link={NCA_audio}/>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <CrossFadeImages images={{then: NCA_Old, now: NCA_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                  <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                    <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Then</p>
                    </div>
                    <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Now</p>
                    </div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <p style={{marginTop: '10px'}} className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Gallery</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",2])} alt="NCA" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={NCA_Gall_3}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",3])} alt="NCA" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={NCA_Gall_1}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",4])} alt="NCA" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={NCA_Gall_2}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img onClick={()=> props.setDisplayedOverlay(["1",5])} alt="NCA" className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} src={NCA_Gall_4}/>
                    </div>
                  </HorizontalScroll>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <div className={mobileStyles.places_chevrons_container}>
                    <div onClick={props.moveBackward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward(1)} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Mayo School of Arts c. 1910s</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="NCA" src={NCA_Old} id={overlay_styles.NCA_Old}></img>,
                      },
                      {
                        description : <span>National College of Arts</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="NCA" src={NCA_Now} id={overlay_styles.NCA_Now}></img>,
                      },
                      {
                        description : <span>Punjab Museum and Mayo School c. 1890</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="NCA" src={NCA_Gall_3} id={overlay_styles.NCA_Gall_3}></img>,
                      },
                      {
                        description : <span>Punjab Museum and Mayo School c. 1910</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="NCA" src={NCA_Gall_1} id={overlay_styles.NCA_Gall_1}></img>,
                      },
                      {
                        description : <span>Mayo School of Arts c. 1911</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="NCA" src={NCA_Gall_2} id={overlay_styles.NCA_Gall_2}></img>,
                      },
                      {
                        description : <span>Stamp celebrating 100 years of NCA</span>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="NCA" src={NCA_Gall_4} id={overlay_styles.NCA_Gall_4}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "ghulamrasool": {
    name: "Ghulam Rasool Building",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div style={{minHeight: window.innerHeight}} className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={ProjectThemesBack} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Ghulam Rasool Building</p>
                </div>
                <div style={{margin: '40px 0px'}} className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top)}>
                  <CrossFadeImages images={{then: GhulamRasool_Old, now: GhulamRasool_Now}} overlayIDs={{then: ["1",0], now: ["1",1]}} time={props.time} setDisplayedOverlay={props.setDisplayedOverlay}/>
                  <div className={`${slideStyles.pill_button_container} ${slideStyles.pill_buttons_inverted}`}>
                    <div onClick={() => props.setTime('Then')} style={props.time === 'Then' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Then</p>
                    </div>
                    <div onClick={() => props.setTime('Now')} style={props.time === 'Now' ? {background: '#FFEB3B', color: 'black'} : {background: 'none', color: 'white'}} className={slideStyles.pill_button}>
                      <p>Now</p>
                    </div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/map" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Map</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : <span>Ghulam Rasool (Smith and Campbell 1922)</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Ghulam Rasool Building" src={GhulamRasool_Old} id={overlay_styles.GhulamRasool_Old}></img>,
                      },
                      {
                        description : <span>Ghulam Rasool Building</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Ghulam Rasool Building" src={GhulamRasool_Now} id={overlay_styles.GhulamRasool_Now}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "gallery": {
    name: "Gallery",
    showinNav: true,
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={gallerySlideBg} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Gallery</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted)}>Choose a section</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <MobileGallerySections
                    sections={[{image: advertisement_Gallery3, title: 'Advertisements', linkTo: '/gallery/advertisements'}, {image: places_Gallery9, title: 'Places', linkTo: '/gallery/places'}, {image: general_Gallery5, title: 'General', linkTo: '/gallery/general'}, {image: poem_Gallery1, title: 'Poems', linkTo: '/gallery/poetry'}, {image: painting_Gallery1, title: 'Paintings', linkTo: '/gallery/paintings'}, {image: stamp_Gallery1, title: 'Stamps', linkTo: '/gallery/stamps'}, {image: narration_Gallery1, title: 'Narrations', linkTo: '/gallery/narrations'}]}
                  />
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.mobile_layout_bottom_button, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.backtoMapButton_container}>
                    <Link to="/themes" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.backtoMap_button} ${mobileStyles.backtoMap_inverted}`}>Back to Themes</p>
                    </Link>
                  </div>
                </div>
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "gallery/advertisements": {
    name: "Gallery",
    showinNav: false,
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={gallerySlideBg} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Advertisements</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}>Click photos to enlarge</p>
                </div>
                <GallerySection
                  id="advertisement_section"
                  addFadeRef={props.addFadeRef}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  images = {{row1: [{image: advertisement_Gallery2, oId: ["1",0], portrait: true}, {image: advertisement_Gallery3, oId: ["1",1], portrait: false}, {image: advertisement_Gallery5, oId: ["1",2], portrait: true}, {image: advertisement_Gallery7, oId: ["1",7], portrait: true}], row2: [{image: advertisement_Gallery4, oId: ["1",3] , portrait: false}, {image: GovernorHouse_Gall_6, oId: ["1",4] , portrait: false}, {image: advertisement_Gallery1, oId: ["1",5], portrait: true}, {image: advertisement_Gallery6, oId: ["1",6], portrait: true}]}}>
                </GallerySection>

                <div className={mobileStyles.gallery_bar_buttons}>
                  <div className={mobileStyles.gallery_bar_button}>
                    <Link to="/gallery" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.gallery_bar_button_t} ${mobileStyles.backtoMap_inverted}`}>Gallery Sections</p>
                    </Link>
                  </div>
                  <div className={mobileStyles.gallery_bar_button}>
                    <Link to="/themes" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.gallery_bar_button_t} ${mobileStyles.backtoThemes_inverted}`}>Back to Themes</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : "An illustrated guide to the Lahore Museum published in 1908",
                        title : "",
                        source : "",
                        render : ()=> <img alt="Lahore Museum" src={advertisement_Gallery2} id={overlay_styles.advertisement_Gallery2}></img>,
                      },
                      {
                        description : "A 1917 poster for an exhibition of craft works in Central Museum, Lahore",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore Museum" src={advertisement_Gallery3} id={overlay_styles.advertisement_Gallery3}></img>,
                      },
                      {
                        description : "An 1893 poster of The Punjab Industrial Exhibition held at Tollington Market and Lahore Museum",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Tollington Market" src={advertisement_Gallery5} id={overlay_styles.advertisement_Gallery5}></img>,
                      },
                      {
                        description : "A poster for an exhibition commemorating Rembrandt, sponsored by Mayo School of Arts (1957)",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Mayo School of Arts" src={advertisement_Gallery4} id={overlay_styles.advertisement_Gallery4}></img>,
                      },
                      {
                        description : <span>An advertisement shows Ayub Khan watering a plant at the Government House</span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Government House Ad" src={GovernorHouse_Gall_6} id={overlay_styles.GovernorHouse_Gall_6}></img>,
                      },
                      {
                        description : <span>A poster by the Capitol Cinema on Mcloed Road for the sreening of a 1931 talkie film <i>Alam-ara</i></span>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Alhamra" src={advertisement_Gallery1} id={overlay_styles.advertisement_Gallery1}></img>,
                      },
                      {
                        description : "A 1910 poster for a drama performed by The Mayo School of Art's Dramatic Club",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Mayo School of Arts" src={advertisement_Gallery6} id={overlay_styles.advertisement_Gallery6}></img>,
                      },
                      {
                        description : "A 1930 advertisement of a soap manufacturer",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Soap Advertisement" src={advertisement_Gallery7} id={overlay_styles.advertisement_Gallery7}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "gallery/places": {
    name: "Gallery",
    showinNav: false,
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={gallerySlideBg} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Places</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}>Click photos to enlarge</p>
                </div>
                <GallerySection
                  id="places_section"
                  increased_row_padding
                  addFadeRef={props.addFadeRef}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  images = {{row1: [{image: places_Gallery1, oId: ["2",0], portrait: false}, {image: places_Gallery2, oId: ["2",1], portrait: false}, {image: places_Gallery3, oId: ["2",2], portrait: false}, {image: places_Gallery4, oId: ["2",3], portrait: false}, {image: places_Gallery5, oId: ["2",4], portrait: false}, {image: places_Gallery6, oId: ["2",5], portrait: false}, {image: places_Gallery21, oId: ["2",6], portrait: false}, {image: places_Gallery15, oId: ["2",14], portrait: false}, {image: places_Gallery16, oId: ["2",15], portrait: false}, {image: places_Gallery17, oId: ["2",16], portrait: false}, {image: places_Gallery7, oId: ["2",20], portrait: true}], row2: [{image: places_Gallery8, oId: ["2",7], portrait: false}, {image: places_Gallery9, oId: ["2",8], portrait: false}, {image: places_Gallery10, oId: ["2",9], portrait: false}, {image: places_Gallery11, oId: ["2",10], portrait: false}, {image: places_Gallery12, oId: ["2",11], portrait: false}, {image: places_Gallery13, oId: ["2",12], portrait: false}, {image: places_Gallery14, oId: ["2",13], portrait: false}, {image: places_Gallery18, oId: ["2",17], portrait: false}, {image: places_Gallery19, oId: ["2",18], portrait: false}, {image: places_Gallery20, oId: ["2",19], portrait: false}]}}>
                </GallerySection>

                <div className={mobileStyles.gallery_bar_buttons}>
                  <div className={mobileStyles.gallery_bar_button}>
                    <Link to="/gallery" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.gallery_bar_button_t} ${mobileStyles.backtoMap_inverted}`}>Gallery Sections</p>
                    </Link>
                  </div>
                  <div className={mobileStyles.gallery_bar_button}>
                    <Link to="/themes" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.gallery_bar_button_t} ${mobileStyles.backtoThemes_inverted}`}>Back to Themes</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="2"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : "The Cathedral (Vintage Postcard)",
                        title : "",
                        source : "",
                        render : ()=> <img alt="Roman Cathedral, Lahore" src={places_Gallery1} id={overlay_styles.places_Gallery1}></img>,
                      },
                      {
                        description : "The Cathedral c. 1880",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Roman Cathedral, Lahore" src={places_Gallery2} id={overlay_styles.places_Gallery2}></img>,
                      },
                      {
                        description : "Lawrence Hall - Lahore Anglican Synod (1890 - 1895)",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lawrence Hall" src={places_Gallery3} id={overlay_styles.places_Gallery3}></img>,
                      },
                      {
                        description : "Lawrence Hall - published in Illustrated London News 1864",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Montgomery Hall" src={places_Gallery4} id={overlay_styles.places_Gallery4}></img>,
                      },
                      {
                        description : "Montgomery Hall c. 1890s",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Montgomery Hall" src={places_Gallery5} id={overlay_styles.places_Gallery5}></img>,
                      },
                      {
                        description : "Montgomery Hall c. 1910s",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Montgomery Hall" src={places_Gallery6} id={overlay_styles.places_Gallery6}></img>,
                      },
                      {
                        description : "Zoo Plaque (Original Aviary)",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Aviary, Lahore Zoo" src={places_Gallery21} id={overlay_styles.places_Gallery21}></img>,
                      },
                      {
                        description : "Lahore Museum Postcard",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore Museum" src={places_Gallery8} id={overlay_styles.places_Gallery8}></img>,
                      },
                      {
                        description : "Artisans at work at The Mayo School of Arts c. 1900s",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Mayo School of Arts" src={places_Gallery9} id={overlay_styles.places_Gallery9}></img>,
                      },
                      {
                        description : "Artisans at work at The Mayo School of Arts c. 1935",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Mayo School of Arts" src={places_Gallery10} id={overlay_styles.places_Gallery10}></img>,
                      },
                      {
                        description : "Artisans at work at The Mayo School of Arts c. 1907",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Mayo School of Arts" src={places_Gallery11} id={overlay_styles.places_Gallery11}></img>,
                      },
                      {
                        description : "Artisans at the Mayo School of Arts working on a model of The Sacred Heart Cathedral Lahore (1910)",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Mayo School of Arts" src={places_Gallery12} id={overlay_styles.places_Gallery12}></img>,
                      },
                      {
                        description : "Regal Chowk c. 1960s",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="The Mall" src={places_Gallery13} id={overlay_styles.places_Gallery13}></img>,
                      },
                      {
                        description : "Government Telegraph Office, Lahore",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Government Telegraph Office, Lahore" src={places_Gallery14} id={overlay_styles.places_Gallery14}></img>,
                      },
                      {
                        description : "Telegraph Office and Mayo Hospital c. 1890",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Telegraph Office and Mayo Hospital" src={places_Gallery15} id={overlay_styles.places_Gallery15}></img>,
                      },
                      {
                        description : "Municipal (Town) Hall, Lahore c. 1890",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Municipal Hall, Lahore" src={places_Gallery16} id={overlay_styles.places_Gallery16}></img>,
                      },
                      {
                        description : "Municipal (Town) Hall, Lahore",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Municipal Hall, Lahore" src={places_Gallery17} id={overlay_styles.places_Gallery17}></img>,
                      },
                      {
                        description : "Municipal (Town) Hall, Lahore c. 1900s",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Municipal Hall, Lahore" src={places_Gallery18} id={overlay_styles.places_Gallery18}></img>,
                      },
                      {
                        description : "Punjab University Hall c. 1920",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="University Hall" src={places_Gallery19} id={overlay_styles.places_Gallery19}></img>,
                      },
                      {
                        description : "Zoological Gardens c. 1940",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore Zoo" src={places_Gallery20} id={overlay_styles.places_Gallery20}></img>,
                      },
                      {
                        description : "Lahore Museum",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore Museum" src={places_Gallery7} id={overlay_styles.places_Gallery7}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "gallery/general": {
    name: "Gallery",
    showinNav: false,
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={gallerySlideBg} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>General</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}>Click photos to enlarge</p>
                </div>
                <GallerySection
                  id="general_section"
                  addFadeRef={props.addFadeRef}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  images = {{row1: [{image: general_Gallery1, oId: ["3",0], portrait: false}, {image: general_Gallery2, oId: ["3",1], portrait: false}, {image: general_Gallery3, oId: ["3",2], portrait: false}, {image: general_Gallery4, oId: ["3",3], portrait: false}, {image: general_Gallery5, oId: ["3",4], portrait: false}, {image: general_Gallery9, oId: ["3",10], portrait: false}, {image: general_Gallery11, oId: ["3",11], portrait: false}], row2: [{image: general_Gallery6, oId: ["3",5], portrait: false}, {image: general_Gallery7, oId: ["3",6], portrait: false}, {image: general_Gallery8, oId: ["3",7], portrait: false}, {image: general_Gallery13, oId: ["3",8], portrait: false}, {image: general_Gallery14, oId: ["3",9], portrait: false}, {image: general_Gallery10, oId: ["3",12], portrait: false}, {image: general_Gallery12, oId: ["3",13], portrait: false}]}}>
                </GallerySection>

                <div className={mobileStyles.gallery_bar_buttons}>
                  <div className={mobileStyles.gallery_bar_button}>
                    <Link to="/gallery" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.gallery_bar_button_t} ${mobileStyles.backtoMap_inverted}`}>Gallery Sections</p>
                    </Link>
                  </div>
                  <div className={mobileStyles.gallery_bar_button}>
                    <Link to="/themes" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.gallery_bar_button_t} ${mobileStyles.backtoThemes_inverted}`}>Back to Themes</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="3"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : "The Mall c. 1930s",
                        title : "",
                        source : "",
                        render : ()=> <img alt="The Mall" src={general_Gallery1} id={overlay_styles.general_Gallery1}></img>,
                      },
                      {
                        description : "The Mall c. 1930s",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="The Mall" src={general_Gallery2} id={overlay_styles.general_Gallery2}></img>,
                      },
                      {
                        description : "The Mall c. 1930s",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="The Mall" src={general_Gallery3} id={overlay_styles.general_Gallery3}></img>,
                      },
                      {
                        description : "The Mall, Hall road junction c. 1941",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="The Mall, Hall road junction" src={general_Gallery4} id={overlay_styles.general_Gallery4}></img>,
                      },
                      {
                        description : "The Mall c. 1950s",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="The Mall" src={general_Gallery5} id={overlay_styles.general_Gallery5}></img>,
                      },
                      {
                        description : "The Mall",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="The Mall" src={general_Gallery6} id={overlay_styles.general_Gallery6}></img>,
                      },
                      {
                        description : "The Mall c. 1959",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="The Mall" src={general_Gallery7} id={overlay_styles.general_Gallery7}></img>,
                      },
                      {
                        description : "Aerial view of the Mall road c. 1920",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Aerial view of the Mall road" src={general_Gallery8} id={overlay_styles.general_Gallery8}></img>,
                      },
                      {
                        description : "Picture taken from Cathedral Bell Tower c. 1900s",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Aerial view of the Mall road" src={general_Gallery13} id={overlay_styles.general_Gallery13}></img>,
                      },
                      {
                        description : "Picture taken from Cathedral Bell Tower c. 1985 (Bryan Porter)",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Aerial view of the Mall road" src={general_Gallery14} id={overlay_styles.general_Gallery14}></img>,
                      },
                      {
                        description : "Map of The Mall c. 1867",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Map of The Mall" src={general_Gallery9} id={overlay_styles.general_Gallery9}></img>,
                      },
                      {
                        description : "Map of The Mall c. 1867",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Map of The Mall" src={general_Gallery11} id={overlay_styles.general_Gallery11}></img>,
                      },
                      {
                        description : "Map of The Mall c. 1927",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Map of The Mall" src={general_Gallery10} id={overlay_styles.general_Gallery10}></img>,
                      },
                      {
                        description : "The Mall c. 1940s",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="The Mall" src={general_Gallery12} id={overlay_styles.general_Gallery12}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "gallery/poetry": {
    name: "Gallery",
    showinNav: false,
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={gallerySlideBg} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Poetry</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}>Click photos to enlarge</p>
                </div>

                <div id="poem_section" className={mobileStyles.poem_section_gallery}>
                  <img onClick={()=> props.setDisplayedOverlay(["6",0])} alt="Poem about Mall Road" className={classNames(mobileStyles.shadowImage)} src={poem_Gallery1}/>
                </div>

                <div className={mobileStyles.gallery_bar_buttons}>
                  <div className={mobileStyles.gallery_bar_button}>
                    <Link to="/gallery" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.gallery_bar_button_t} ${mobileStyles.backtoMap_inverted}`}>Gallery Sections</p>
                    </Link>
                  </div>
                  <div className={mobileStyles.gallery_bar_button}>
                    <Link to="/themes" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.gallery_bar_button_t} ${mobileStyles.backtoThemes_inverted}`}>Back to Themes</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="6"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : "A poem by Qamar Jalalabadi",
                        title : "",
                        source : "",
                        render : ()=> <img alt="Poem" src={poem_Gallery1} id={overlay_styles.poem_Gallery1}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "gallery/paintings": {
    name: "Gallery",
    showinNav: false,
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={gallerySlideBg} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Paintings</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}>Click photos to enlarge</p>
                </div>
                <GallerySection
                  id="painting_section"
                  addFadeRef={props.addFadeRef}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  images = {{row1: [{image: painting_Gallery1, oId: ["4",0], portrait: false}, {image: GPO_Gall_9, oId: ["4",3], portrait: false}], row2: [{image: painting_Gallery2, oId: ["4",1], portrait: true}, {image: Anarkali_Gall_3, oId: ["4",2], portrait: true}]}}>
                </GallerySection>

                <div className={mobileStyles.gallery_bar_buttons}>
                  <div className={mobileStyles.gallery_bar_button}>
                    <Link to="/gallery" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.gallery_bar_button_t} ${mobileStyles.backtoMap_inverted}`}>Gallery Sections</p>
                    </Link>
                  </div>
                  <div className={mobileStyles.gallery_bar_button}>
                    <Link to="/themes" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.gallery_bar_button_t} ${mobileStyles.backtoThemes_inverted}`}>Back to Themes</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="4"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : "An artist's impression of The Mall",
                        title : "",
                        source : "",
                        render : ()=> <img alt="An artist's impression of The Mall" src={painting_Gallery1} id={overlay_styles.painting_Gallery1}></img>,
                      },
                      {
                        description : "An artist's impression of The Mall",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="An artist's impression of The Mall" src={painting_Gallery2} id={overlay_styles.painting_Gallery2}></img>,
                      },
                      {
                        description : "An artist's impression of Anarkali Market",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="An artist's impression of Anarkali Market" src={Anarkali_Gall_3} id={overlay_styles.Anarkali_Gall_3}></img>,
                      },
                      {
                        description : "An artist's impression of the General Post Office (GPO)",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="An artist's impression of the General Post Office (GPO)" src={GPO_Gall_9} id={overlay_styles.GPO_Gall_9}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "gallery/stamps": {
    name: "Gallery",
    showinNav: false,
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={gallerySlideBg} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Stamps</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}>Click photos to enlarge</p>
                </div>
                <GallerySection
                  id="stamp_section"
                  addFadeRef={props.addFadeRef}
                  images = {{row1: [{image: stamp_Gallery1, oId: ["5",0], portrait: true}, {image: Aitchison_Gall_5, oId: ["5",1], portrait: false}, {image: HighCourt_Gall_17, oId: ["5",4], portrait: false}], row2: [{image: stamp_Gallery2, oId: ["5",2], portrait: false}, {image: GPO_Gall_12, oId: ["5",3], portrait: true}]}}
                  setDisplayedOverlay={props.setDisplayedOverlay}>
                </GallerySection>

                <div className={mobileStyles.gallery_bar_buttons}>
                  <div className={mobileStyles.gallery_bar_button}>
                    <Link to="/gallery" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.gallery_bar_button_t} ${mobileStyles.backtoMap_inverted}`}>Gallery Sections</p>
                    </Link>
                  </div>
                  <div className={mobileStyles.gallery_bar_button}>
                    <Link to="/themes" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.gallery_bar_button_t} ${mobileStyles.backtoThemes_inverted}`}>Back to Themes</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="5"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [
                      {
                        description : "Lahore Museum Centenary Stamp",
                        title : "",
                        source : "",
                        render : ()=> <img alt="Lahore Museum Centenary Stamp" src={stamp_Gallery1} id={overlay_styles.stamp_Gallery1}></img>,
                      },
                      {
                        description : "Aitchison College Centenary Stamp",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Aitchison College Centenary Stamp" src={Aitchison_Gall_5} id={overlay_styles.Aitchison_Gall_5}></img>,
                      },
                      {
                        description : "NCA Centenary Stamp",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="NCA Centenary Stamp" src={stamp_Gallery2} id={overlay_styles.stamp_Gallery2}></img>,
                      },
                      {
                        description : "GPO Stamp",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="GPO Stamp" src={GPO_Gall_12} id={overlay_styles.GPO_Gall_12}></img>,
                      },
                      {
                        description : "Stamp celebrating 150 years of Lahore High Court",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Lahore High Court Stamp" src={HighCourt_Gall_17} id={overlay_styles.HighCourt_Gall_17}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "gallery/narrations": {
    name: "Gallery",
    showinNav: false,
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div className={mobileStyles.absolute_Bg_Rel_slide_parent}>
                <img src={gallerySlideBg} className={mobileStyles.absoluteSlideBg}></img>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top)}>
                  <p className={classNames(mobileStyles.slide_page_Title, mobileStyles.slide_page_Title_inverted)}>Narrations</p>
                  <p className={classNames(mobileStyles.slide_page_Desc, mobileStyles.slide_page_Desc_inverted, mobileStyles.slide_page_Desc_audio)}>Click photos to enlarge</p>
                </div>
                <GallerySection
                  id="narration_section"
                  addFadeRef={props.addFadeRef}
                  images = {{row1: [{image: narration_Gallery1, oId: ["7",0], portrait: true}, {image: narration_Gallery2, oId: ["7",1], portrait: true}, {image: places_Gallery8, oId: ["7", 2], portrait: false}, {image: HighCourt_Gall_19, oId: ["7",6], portrait: true}], row2: [{image: places_Gallery6, oId: ["7",3], portrait: false}, {image: places_Gallery4, oId: ["7",4], portrait: false}, {image: places_Gallery5, oId: ["7",5], portrait: false}]}}
                  setDisplayedOverlay={props.setDisplayedOverlay}>
                </GallerySection>

                <div className={mobileStyles.gallery_bar_buttons}>
                  <div className={mobileStyles.gallery_bar_button}>
                    <Link to="/gallery" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.gallery_bar_button_t} ${mobileStyles.backtoMap_inverted}`}>Gallery Sections</p>
                    </Link>
                  </div>
                  <div className={mobileStyles.gallery_bar_button}>
                    <Link to="/themes" style={{textDecoration: 'none', color: 'inherit'}}>
                      <p className={`${mobileStyles.gallery_bar_button_t} ${mobileStyles.backtoThemes_inverted}`}>Back to Themes</p>
                    </Link>
                  </div>
                </div>
                <Overlay
                  oId="7"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  withAudio
                  slides={
                    [
                      {
                        description : <span>Account of Winston Churchill riding a horse on Mall road from Lahore Cantt to Tollinton Market. From <i>Yadon Ki Basti</i> by Khalid Masood Qureshi</span>,
                        title : "",
                        source : "",
                        audioLink: churchill_audio,
                        render : ()=> <img alt="Portrait of Winston Churchill" src={narration_Gallery1} id={overlay_styles.narration_Gallery1}></img>,
                      },
                      {
                        description : <span>An excerpt on The Ganga Ram Hospital From Som Anand’s <i>Portrait of a Lost City</i></span>,
                        title : "Sample Title",
                        source : "",
                        audioLink: ganga_ram_hospital_audio,
                        render : ()=> <img alt="Portrait of Sir Ganga Ram" src={narration_Gallery2} id={overlay_styles.narration_Gallery2}></img>,
                      },
                      {
                        description : <span>A description of the Lahore Museum taken from <i>Lahore: A Memoir</i> by Muhammad Saeed</span>,
                        title : "Sample Title",
                        source : "",
                        audioLink: museam_audio,
                        render : ()=> <img alt="Lahore Museum" src={places_Gallery8} id={overlay_styles.places_Gallery8}></img>,
                      },
                      {
                        description : <span>A description of the British ‘Club’ Culture taken from <i>Lahore: A Memoir</i> by Muhammad Saeed</span>,
                        title : "Sample Title",
                        source : "",
                        audioLink: mont_audio,
                        render : ()=> <img alt="Montgomery Hall" src={places_Gallery6} id={overlay_styles.places_Gallery6}></img>,
                      },
                      {
                        description : <span>An excerpt on the Lawrence Garden taken from <i>Lahore: A Memoir</i> by Muhammad Saeed</span>,
                        title : "Lawrence Garden",
                        source : "",
                        audioLink: lawrance_garden,
                        render : ()=> <img alt="Lawrence Garden" src={places_Gallery4} id={overlay_styles.places_Gallery4}></img>,
                      },
                      {
                        description : <span>An account of the Montgomery Hall taken from <i>Lahore: A Memoir</i> by Muhammad Saeed</span>,
                        title : "Sample Title",
                        source : "",
                        audioLink: mont1_audio,
                        render : ()=> <img alt="Montgomery Hall" src={places_Gallery5} id={overlay_styles.places_Gallery5}></img>,
                      },
                      {
                        description : <span>A description of the statue of Sir John Lawrence taken from <i>Lahore: A Memoir</i> by Muhammad Saeed</span>,
                        title : "Sample Title",
                        source : "",
                        audioLink: lawrance_stat_audio,
                        render : ()=> <img alt="Lawrence Statue" src={HighCourt_Gall_19} id={overlay_styles.HighCourt_Gall_19}></img>,
                      }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "credits": {
    name: "Credits",
    showinNav: true,
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div>
                <ProjectCreditsMobile
                  image={ProjectCreditsBack}
                  disclaimer=<span>These projects are based on research conducted by students for the course <i>Walking in the City: Mapping Everyday Life in Lahore.</i></span>
                  projectName="The Mall: History and Culture, Now and Then"
                  studentNames="Nayyab Naveed, Aisha Zaman, Amal Zahra, Maahliqa Mehrissa Qureshi, Maryam Jamil, Rabia Tufail and Zoya Wasif"
                  supervisor={{name: 'Dr Ali Usman Qasmi', desig: 'Associate Professor (History), Department of Humanities and Social Sciences, LUMS'}}
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  }
}

const mobileImageArr = [];

export {
    slideMap,
    slideOrder,
    imageArr,
    chapterArr,
    mobileSlideMap,
    mobileImageArr
};
